const es = {
  common: {
    photo: 'Foto',
    continue: 'Continuar',
    dragToReorder: 'Arrastra para reordenar', dragToMove: 'Arrastra para mover',
    select: "Seleccionar", noResults: "Sin resultados",
    save: 'Guardar', cancel: 'Cancelar', edit: 'Editar', delete: 'Eliminar', add: 'Añadir',
    back: 'Volver', close: 'Cerrar', copy: 'Copiar', copied: '¡Copiado!',
    loadingApp: 'Cargando Gromly',
    loading: 'Cargando…', search: 'Buscar', open: 'Abrir', confirm: 'Confirmar',
    enable: 'Activar', disable: 'Desactivar', create: 'Crear', invite: 'Invitar',
    remove: 'Eliminar', generate: 'Generar',
    fromDocument: 'Del documento', fromDocumentHint: 'Importado de tu documento — es tu base fija. El asistente construye alrededor y no la reorganiza ni la elimina.',
    deleting: 'Eliminando…', required: 'Requerido', confirmDelete: '¿Estás seguro? Esta acción no se puede deshacer.',
    clear: 'Borrar', today: 'Hoy',
    pickTime: 'Elegir hora', pickDate: 'Elige una fecha', pickDateTime: 'Elige fecha y hora', time: 'Hora', done: 'Listo',
    areYouSure: '¿Seguro?', yesDelete: 'Sí, eliminar', deleteFailed: 'No se pudo eliminar',
    accept: 'Aceptar', discard: 'Descartar', ai: 'IA', or: 'o',
    error: 'Ha ocurrido un error', saving: 'Guardando…',
  },
  upload: {
    fileTooLarge: '«{{name}}» es demasiado grande: el límite son {{size}}',
    fileUnsupported: '«{{name}}» no es un tipo de archivo admitido',
    imageUnreadable: 'No hemos podido leer la foto «{{name}}». Prueba a exportarla como JPEG.',
    storageFull: "Has llegado al límite de espacio para fotos",
    storageFullBatch_one: "Has llegado al límite de espacio para fotos: {{count}} foto no se ha subido",
    storageFullBatch_other: "Has llegado al límite de espacio para fotos: {{count}} fotos no se han subido",
    progress: { title: "Subiendo foto {{current}} de {{total}}", keepOpen: "No cierres esta página hasta que termine" },
  },
  nav: {
    myTrips: 'Mis viajes', menu: 'Menú', docs: 'Docs', signOut: 'Cerrar sesión', security: 'Seguridad', agencyHome: "Inicio", collapseMenu: "Plegar menú", expandMenu: "Desplegar menú", agencyTrips: "Viajes", mode: { label: "Cambiar a", personal: "Mis viajes", admin: "Administración" }, explore: 'Explorar', accountSettings: 'Ajustes de cuenta',
    lightMode: 'Cambiar a modo claro', darkMode: 'Cambiar a modo oscuro', language: 'Idioma',
  },
  auth: {
    unverified: {
      title: 'Verifica tu email',
      body: 'Te hemos enviado un enlace a {{email}}. Algunas acciones (invitar, publicar) están bloqueadas hasta que lo confirmes.',
      resend: 'Reenviar',
      resent: 'Email reenviado. Revisa tu bandeja.',
      alreadyVerified: 'Tu email ya está verificado, recarga la página.',
      resendFailed: 'No se ha podido reenviar. Inténtalo en unos minutos.',
    },
    login: {
      heroTitle: 'Planifica cada\naventura',
      heroSubtitle: 'Itinerarios, reservas, gastos y las pequeñas notas que tu gente recordará — guardado todo en un lugar tranquilo, compartido solo con quienes van.',
      heroFeatures: { flights: 'Vuelos', hotels: 'Hoteles', places: 'Lugares', expenses: 'Gastos', checklists: 'Listas', share: 'Compartir' },
      heroEyebrow: 'Donde empieza cada viaje',
      heroLine1: 'Planifica lo', heroLine2: 'inolvidable,', heroLine3: 'olvídate del', heroLine4: 'resto.',
      title: 'Bienvenido de nuevo', subtitle: 'Inicia sesión en tu cuenta',
      email: 'Correo electrónico', password: 'Contraseña', submit: 'Iniciar sesión',
      noAccount: '¿Sin cuenta?', createOne: 'Crear una',
      errorDefault: 'Correo o contraseña incorrectos',
      googleAccount: 'Esta cuenta entra con Google. Elígela en el selector de cuenta, o ponle una contraseña.',
      appleAccount: 'Esta cuenta entra con Apple. Usa «Continuar con Apple», o ponle una contraseña.',
      setPassword: 'Poner una contraseña a esta cuenta',
      tooManyAttempts: 'Demasiados intentos. Espera unos minutos y vuelve a probar.',
      hidePassword: 'Ocultar contraseña', showPassword: 'Mostrar contraseña',
      breadcrumb: 'Cuenta · iniciar sesión',
      newHere: '¿Nuevo aquí?',
      createAccount: 'Crear una cuenta',
      continueJourney: 'Continúa tu viaje.',
      continueSubtitle: 'Inicia sesión para retomar donde lo dejaste — tus viajes están donde los dejaste.',
      forgot: '¿Olvidada?',
      passwordPlaceholder: 'Mínimo 8 caracteres',
      rememberMe: 'Mantenerme conectado en este dispositivo',
      orContinueWith: 'o continúa con',
      continueWithGoogle: 'Continuar con Google',
      continueWithApple: 'Continuar con Apple',
      footer: { privacy: 'Privacidad', terms: 'Términos', status: 'Estado', copyright: '© 2026 Gromly · Vestigi Platform, S.L.' },
    },
    forgotPassword: {
      eyebrow: 'Recuperar cuenta',
      title: '¿Olvidaste tu contraseña?',
      subtitle: 'Escribe el email con el que te registraste y te enviamos un enlace para elegir una nueva.',
      emailLabel: 'Correo electrónico',
      submit: 'Enviar enlace',
      failed: 'No pudimos enviar el email. Inténtalo de nuevo en unos minutos.',
      sentTitle: 'Revisa tu bandeja',
      sentBody: 'Si {{email}} tiene cuenta con nosotros, el enlace ya está en camino.',
      sentHint: 'El enlace caduca en una hora y solo se puede usar una vez. ¿No lo ves? Mira en spam.',
      backToLogin: 'Volver a iniciar sesión',
    },
    resetPassword: {
      eyebrow: 'Nueva contraseña',
      title: 'Elige una contraseña nueva',
      subtitle: 'Que puedas recordar: la necesitarás también para entrar desde otros dispositivos.',
      checking: 'Comprobando tu enlace…',
      newPassword: 'Nueva contraseña',
      confirmPassword: 'Repite la contraseña',
      confirmPlaceholder: 'Escríbela otra vez',
      tooShort: 'Mínimo {{min}} caracteres.',
      mismatch: 'Las dos contraseñas no coinciden.',
      submit: 'Cambiar contraseña',
      failed: 'No pudimos cambiar tu contraseña. Inténtalo de nuevo.',
      twoFactorNeeded: 'Esta cuenta tiene verificación en dos pasos. Introduce tu código para continuar.',
      twoFactorHint: 'El de tu app de autenticación, el mismo que usas para entrar.',
      invalidTitle: 'Este enlace ya no sirve',
      invalidBody: 'Los enlaces caducan en una hora y solo se pueden usar una vez. Pide uno nuevo y lo tendrás en segundos.',
      requestNew: 'Pedir un enlace nuevo',
      doneTitle: 'Contraseña cambiada',
      doneBody: 'Hemos cerrado tu sesión en el resto de dispositivos. Entra con la nueva contraseña y sigue donde lo dejaste.',
      goToLogin: 'Ir a iniciar sesión',
    },
    twoFactor: {
      title: 'Verificación en dos pasos',
      subtitle: 'Introduce el código de 6 dígitos de tu app de autenticación',
      codeLabel: 'Código de autenticación',
      verify: 'Verificar',
      back: 'Volver al inicio de sesión',
      invalidCode: 'Código inválido o caducado',
      modalTitle: 'Verificación en dos pasos',
      statusEnabled: 'La 2FA está activada. Tu cuenta está protegida con una app de autenticación.',
      statusDisabled: 'La 2FA está desactivada. Actívala para añadir una capa extra de seguridad.',
      enable: 'Activar 2FA',
      disable: 'Desactivar 2FA',
      scanQr: 'Escanea este código QR con Google Authenticator, Authy o cualquier app TOTP.',
      manualEntry: 'O introduce este secreto manualmente:',
      confirm: 'Activar 2FA',
      confirmDisable: 'Desactivar 2FA',
      disablePrompt: 'Introduce tu código de autenticación actual para desactivar la 2FA.',
      setupError: 'No se pudo iniciar la configuración de 2FA. Inténtalo de nuevo.',
    },
    register: {
      nationality: "Nacionalidad",
      heroTitle: 'Tu próxima\naventura te espera',
      heroSubtitle: 'Crea una cuenta y empieza a planificar\nviajes inolvidables con tu gente.',
      heroFeatures: ['Constructor de itinerarios día a día', 'Gastos compartidos y deudas', 'Lugares, reservas y mapas', 'Invita a compañeros de viaje'],
      heroEyebrow: 'Tu próxima aventura comienza aquí',
      heroLine1a: 'Todo gran ', heroLine1b: 'viaje', heroLine2a: 'empieza con un ', heroLine2b: 'plan.',
      heroSubheading: 'Construye itinerarios, divide gastos y guarda todos los detalles del viaje en un lugar tranquilo — compartido solo con las personas que van.',
      title: 'Crear cuenta', subtitle: 'Empieza a planificar tus viajes',
      displayName: 'Nombre visible', username: 'Nickname', email: 'Correo electrónico', password: 'Contraseña',
      passwordPlaceholder: 'Mínimo 8 caracteres', submit: 'Crear cuenta',
      hasAccount: '¿Ya tienes cuenta?', signIn: 'Inicia sesión',
      errorDefault: 'El registro ha fallado',
      hidePassword: 'Ocultar contraseña', showPassword: 'Mostrar contraseña',
      invitePreview: 'Tras crear tu cuenta te uniremos al viaje "{{tripName}}" de {{inviterName}}.',
      mustAcceptTerms: 'Debes aceptar los términos y la política de privacidad para continuar.',
      toastJoined: 'Te has unido al viaje',
      toastInviteExpired: 'Cuenta creada, pero no hemos podido añadirte al viaje (invitación expirada)',
      toastVerifyEmail: 'Te hemos enviado un email para verificar tu cuenta',
      breadcrumb: 'Cuenta · crear',
      alreadyMember: '¿Ya eres miembro?',
      signInLink: 'Iniciar sesión',
      tripInviteHeader: 'Invitación de viaje',
      newAccountHeader: 'Cuenta nueva',
      startAdventure: 'Comienza tu aventura.',
      createSubtitle: 'Crea tu cuenta y empieza a planificar tu primer viaje.',
      acceptStart: 'He leído y acepto los',
      terms: 'Términos del servicio',
      and: 'y la',
      privacy: 'Política de privacidad',
      or: 'o',
      orWithEmail: 'o con email',
    },
    verify: {
      checking: 'Verificando email…',
      success: 'Email verificado',
      failed: 'No hemos podido verificar',
      successBody: 'Tu cuenta está activa. Ya puedes invitar a amigos a tus viajes y publicar contenido.',
      failedBody: 'El enlace es inválido o ha expirado. Desde tu perfil puedes pedir un enlace nuevo.',
      goToDashboard: 'Ir al dashboard',
      goHome: 'Ir al inicio',
    },
    completeProfile: {
      eyebrow: 'Un paso más',
      title: 'Completa tu perfil.',
      subtitle: 'Elige un nickname y acepta nuestras políticas para empezar.',
      nicknameLabel: 'Nickname',
      nicknameHint: 'Mínimo 3 caracteres. Letras, números y guión bajo.',
      acceptStart: 'He leído y acepto los',
      terms: 'Términos de uso',
      and: 'y la',
      privacy: 'Política de privacidad',
      continue: 'Continuar',
      mustAccept: 'Debes aceptar los términos y la política de privacidad para continuar.',
      saveFailed: 'No se pudo guardar el perfil',
    },
    callback: {
      signingIn: 'Iniciando sesión…',
    },
  },
  invite: {
    errors: {
      invalidTitle: 'Invitación no válida',
      invalidBody: 'El enlace no corresponde a ninguna invitación activa.',
      cancelledTitle: 'Invitación cancelada',
      cancelledBody: 'La persona que te invitó ha cancelado esta invitación.',
      expiredTitle: 'Invitación caducada',
      expiredBody: 'Este enlace ha expirado. Pide una nueva invitación.',
      usedTitle: 'Invitación ya usada',
      usedBody: 'Este enlace ya se utilizó antes.',
      ownTitle: 'Ya eres dueño del viaje',
      ownBody: 'Este link está pensado para otra persona. Si quieres probar cómo se acepta una invitación, ábrelo en una ventana de incógnito o con otra cuenta.',
      emailMismatchTitle: "Esta invitación es para otro correo",
      emailMismatchBody: "Tu agencia la envió a otra dirección. Entra con el correo que le diste.",
      failedTitle: 'Algo no ha ido bien',
      failedBody: 'No hemos podido cargar la invitación. Inténtalo de nuevo.',
    },
    joined: 'Te has unido al viaje',
    goDashboard: 'Volver al dashboard',
    goHome: 'Ir al inicio',
    eyebrow: 'Invitación de viaje',
    inviterText: '{{inviterName}} te invita',
    toCollaborate: 'A colaborar en el viaje "{{tripName}}".',
    roleEditor: 'Editor',
    roleViewer: 'Sólo lectura',
    joining: 'Uniéndote al viaje…',
    needAccount: 'Para aceptar necesitas una cuenta en Gromly. Si es tu primera vez, créala en 30 segundos. Si ya tienes cuenta, entra con ella.',
    createAndJoin: 'Crear cuenta y unirme',
    haveAccount: 'Ya tengo cuenta · iniciar sesión',
    expiresOn: 'Expira el {{date}}',
  },
  dashboard: {
    deleteTripAria: 'Eliminar viaje',
    greeting: { morning: 'Buenos días', afternoon: 'Buenas tardes', evening: 'Buenas noches' },
    title: 'Tus aventuras', tagline: 'Planifica juntos. Viaja mejor.', searchPlaceholder: 'Buscar viajes…',
    newTrip: 'Nuevo viaje', newTripShort: 'Nuevo', addTripHint: 'Añade destino, fechas y viajeros',
    stats: { totalTrips: 'Total viajes', destinations: 'Destinos', upcoming: 'Próximos', nights: 'Noches', avgBudget: 'Presupuesto medio', subPast: '{{count}} pasados', subUnique: 'únicas', subTotal: 'total', subPerTrip: 'por viaje', subCredits: 'créditos' },
    filter: { all: 'Todos', upcoming: 'Próximos', past: 'Pasados' },
    sections: { following: 'Viajes que sigues', upcoming: 'Próximos', past: 'Pasados', horizon: 'En el horizonte', brewing: 'Viajes en preparación', alsoPlanning: 'También planificando', pastKicker: 'Donde has estado', pastTitle: 'Memoria', memoryLane: 'Memory lane · ya vividos', seeAll: 'Ver los {{count}}' },
    eyebrow: { trips_one: '{{count}} viaje', trips_other: '{{count}} viajes', lived_one: '{{count}} vivido', lived_other: '{{count}} vividos' },
    summary: { label: 'Resumen', trips_one: '{{count}} viaje', trips_other: '{{count}} viajes', dests_one: '{{count}} destino', dests_other: '{{count}} destinos', nights_one: '{{count}} noche', nights_other: '{{count}} noches', avg: '{{amount}} promedio', credits: '{{credits}} créditos' },
    toast: {
      loadFailed: 'Error al cargar los viajes',
      deleted: 'Viaje eliminado',
      published: '¡Viaje publicado en la comunidad!',
      unpublished: 'Viaje despublicado',
    },
    welcome: {
      title: '¡Bienvenido a Gromly!',
      body: 'Hemos creado un viaje de ejemplo a Barcelona para que puedas explorar todas las funciones. Elimínalo cuando quieras.',
      explore: 'Explorar demo →',
      create: 'Crear mi primer viaje',
    },
    community: {
      removeTitle: 'Quitar de la comunidad',
      shareTitle: 'Compartir viaje con la comunidad',
      removeBody: '{{name}} dejará de estar visible para otros viajeros.',
      shareBody: '{{name}} se publicará en el feed de la comunidad y será visible para todos en Gromly.',
      remove: 'Quitar',
      publish: 'Publicar viaje',
      shared: 'Compartido',
      share: 'Compartir',
      community: 'Comunidad',
    },
    hero: {
      onRoadNow: 'De viaje ahora',
      nextAdventure: 'Tu próxima aventura',
      departingIn: 'Empieza en',
      day: 'día',
      days: 'días',
      daysLeft: 'Días restantes',
      left: 'restantes',
      onRoad: 'De viaje',
      planning: 'Planificando',
      night: 'noche',
      nights: 'noches',
      openItinerary: 'Abrir itinerario',
      fieldDestination: 'Destino',
      fieldDates: 'Fechas',
      fieldTravelers: 'Viajeros',
      people_one: '{{count}} persona',
      people_other: '{{count}} personas',
    },
    card: {
      active: 'En curso',
      tomorrow: 'Mañana',
      inDays_one: 'en {{count}} día',
      inDays_other: 'en {{count}} días',
    },
    today: '¡Hoy!', tomorrow: 'Mañana', daysUntil: '{{count}}d', pastLabel: 'Pasado',
    delete: 'Eliminar', open: 'Abrir',
    deleteTrip: { title: '¿Eliminar este viaje?', body: '"{{name}}" y todo su itinerario, lugares, gastos y reservas se eliminarán permanentemente.' },
    empty: {
      kicker: 'Empieza aquí',
      title: 'Planifica tu primer viaje',
      subtitle: 'Crea un viaje, invita a tu compañero de aventura y empieza a organizar itinerario, lugares, gastos y checklists — todo en un lugar.',
      cta: 'Nuevo viaje',
      exploreCta: 'Explorar viajes',
      featuresLabel: 'Funciones',
      features: [
        { label: 'Itinerario día a día', desc: 'Actividades, horarios y orden' },
        { label: 'Lugares y mapa', desc: 'Guarda sitios y ve la ruta' },
        { label: 'Planifica con IA', desc: 'La IA propone tu viaje' },
        { label: 'Vuelos y hoteles', desc: 'Reservas y entradas en un sitio' },
        { label: 'Gastos compartidos', desc: 'Liquidación automática de deudas' },
        { label: 'Planificad en equipo', desc: 'Invita y planificad juntos' },
        { label: 'Listas y equipaje', desc: 'Documentos y checklists de maleta' },
        { label: 'Galería de fotos', desc: 'Vuestros recuerdos, día a día' },
      ],
    },
    modalTitle: 'Planifica un nuevo viaje',
    newTripWizard: {
      progress: "Paso {{current}} de {{total}}",
      back: "Atrás",
      stepLabel: {
        destination: "Destino",
        dates: "Fechas",
        legs: "Noches",
        travellers: "Viajeros",
        bookings: "Reservas",
        start: "Cómo empezamos",
        documents: "Documentos",
        style: "Vuestro estilo",
        summary: "Resumen",
      },
      ask: {
        destination: "¿Adónde vas?",
        dates: "¿Cuándo?",
        legs: "¿Cuántas noches en cada sitio?",
        travellers: "¿Quién viene?",
        bookings: "¿Tienes ya alguna reserva?",
        start: "¿Cómo quieres empezar?",
        documents: "Sube lo que ya tengas",
        style: "¿Cómo os gusta viajar por {{destination}}?",
        summary: "Tu viaje está listo para arrancar",
      },
      hint: {
        destination: "Una ciudad, una región o un país entero. ¿Vas a varios? Añádelos uno a uno.",
        legs: "Tienen que sumar las noches del viaje.",
        travellers: "Añade a todos los que viajan: desde el primer día podréis repartir gastos, vuelos y maleta.",
        bookings: "Vuelos, alojamiento, transporte o entradas, separados por tipo. Los leemos y los añadimos a Docs con el archivo adjunto. Cada tipo gasta un crédito de IA.",
        start: "Luego podrás cambiarlo todo.",
        documents: "Reservas, billetes o un itinerario en PDF, Word o Excel. No se añade nada hasta que lo confirmes.",
        style: "Para que las sugerencias encajen contigo.",
        summary: "Revísalo y ponle nombre.",
      },
      travellersCount_one: "Solo yo",
      travellersCount_other: "Somos {{count}}",
      travellersFewer: "Uno menos",
      travellersMore: "Uno más",
      travellerDefaultName: "Viajero {{number}}",
      ticketsCount_one: "{{count}} reserva",
      ticketsCount_other: "{{count}} reservas",
      ticketsNone: "Ninguna",
      ticketsSkip: "Saltar",
      ticketsMax: "Hasta {{count}} archivos por tipo.",
      ticketsAddTo: "Añadir archivos a {{kind}}",
      travellerName: "Nombre",
      travellerRemove: "Quitar viajero",
      you: "tú",
      birthDateLabel: "Fecha de nacimiento (opcional)",
      birthDateHint: "Opcional. Con la fecha de nacimiento podremos avisarte de tarifas y ventajas por edad y ajustar mejor el plan a quien viaja.",
      emailLabel: "Email",
      emailPlaceholder: "nombre@email.com",
      emailHint: "Le enviaremos una invitación para unirse al viaje.",
      addEmail: "Invitar por email",
      start: {
        recommended: "Recomendado",
        ai: {
          title: "Planifícalo con IA",
          description: "Te proponemos lugares, un itinerario día a día y consejos prácticos.",
        },
        documents: {
          title: "Tengo documentos",
          description: "Sube reservas o un itinerario y montamos el viaje a partir de ahí.",
        },
        empty: {
          title: "Empiezo de cero",
          description: "Crea el viaje vacío y llénalo a tu ritmo.",
        },
      },
      documentsFound: "Esto es lo que hemos encontrado",
      complementAi: "Completa con IA lo que falte",
      complementAiHint: "Añadimos lugares e itinerario alrededor de lo que ya cubren tus documentos.",
      paceLabel: "Ritmo",
      budgetLabel: "Presupuesto",
      interestsLabel: "¿Qué os apetece?",
      notesLabel: "¿Algo más? (opcional)",
      generatingTitle: "Preparando tu viaje",
      invitesFailed_one: "No se ha podido enviar una invitación: puedes enviarla desde Participantes.",
      invitesFailed_other: "No se han podido enviar {{count}} invitaciones: puedes enviarlas desde Participantes.",
      groupForPrompt_one: "una persona que viaja sola",
      groupForPrompt_other: "un grupo de {{count}} (las edades están en la lista de viajeros)",
      destinationPlaceholder: 'Ej: Lisboa, Portugal',
      destinationAddAnother: "Añade otro destino",
      destinationRemove: "Quitar {{name}}",
      legNights_one: "{{count}} noche",
      legNights_other: "{{count}} noches",
      legNightsFewer: "Una noche menos en {{name}}",
      legNightsMore: "Una noche más en {{name}}",
      legsTotal_one: "{{assigned}} de {{count}} noche",
      legsTotal_other: "{{assigned}} de {{count}} noches",
      legDays: "Días {{from}}–{{to}}",
      legDay: "Día {{day}}",
      legDaysShort: "días {{from}}–{{to}}",
      legForPrompt_one: "{{name}} ({{count}} noche)",
      legForPrompt_other: "{{name}} ({{count}} noches)",
      datesPlaceholder: "Ej: del 3 al 10 de agosto, o 'la primera semana de septiembre'",
      datesParseFailed: 'No he entendido bien esas fechas — ¿puedes escribirlas de otra forma?',
      datesPickHint: 'o elígelas en el calendario de abajo',
      datesAnswer_one: '{{start}} – {{end}} · {{count}} noche',
      datesAnswer_other: '{{start}} – {{end}} · {{count}} noches',
      preferencesPlaceholder: 'Ej: ritmo relajado, nos encanta la gastronomía local...',
      interestsLoading: 'Buscando qué suele hacer la gente aquí…',
      interestsFailed: 'No hemos podido cargar sugerencias para este destino — puedes continuar igualmente.',
      pace: { relaxed: 'Relajado', balanced: 'Equilibrado', packed: 'Intenso' },
      budget: { budget: 'Económico', mid: 'Gama media', splurge: 'Sin límites' },
      nameLabel: 'Nombre del viaje',
      currencyLabel: 'Moneda base',
      currencyHint: 'Los balances y el presupuesto se muestran en esta moneda; los gastos en otras monedas se convierten a ella.',
      defaultName: 'Viaje a {{destination}}',
      next: 'Continuar',
      editAnswer: 'Editar respuesta',
      importFromDocument: 'Importar desde documentos',
      documentsRemove: "Quitar documentos",
      importing: 'Leyendo tu documento…',
      importFailed: 'No hemos podido leer ese documento — prueba con otro archivo o continúa manualmente.',
      importInsufficientCredits: 'Te has quedado sin créditos de IA — puedes crear el viaje manualmente igualmente.',
      create: 'Crear viaje', created: '¡Viaje creado!', failed: 'Error al crear el viaje',
      noSpecificInterests: 'sin intereses concretos especificados',
      placesSeedPrompt: 'Estamos planificando un viaje de {{nights}} noches a {{destination}} con ritmo {{pace}}, para {{travelers}}, presupuesto {{budget}}. Nos interesa especialmente: {{interests}}. {{notes}} Sugiere unos {{targetCount}} lugares estupendos que encajen con esto — una mezcla de los intereses de arriba más un par de buenos restaurantes o cafés cerca.',
      itinerarySeedPrompt: 'Organiza todos los lugares que acabas de guardar en un itinerario completo día a día para todo el viaje, manteniendo un ritmo {{pace}}.',
      tipsSeedPrompt: 'Dame los consejos más esenciales y prácticos para viajar a {{destination}} — requisitos de entrada (visado, ETA, ESTA…), vacunas recomendadas o precauciones sanitarias, seguro de viaje, y cualquier otro consejo local realmente útil.',
      generating: {
        stepPlaces: 'Lugares en {{destination}}',
        stepPlacesFound_one: '{{count}} encontrado',
        stepPlacesFound_other: '{{count}} encontrados',
        stepItinerary_one: 'Tu itinerario de {{count}} noche',
        stepItinerary_other: 'Tu itinerario de {{count}} noches',
        stepItineraryDone_one: '{{count}} día',
        stepItineraryDone_other: '{{count}} días',
        stepTips: 'Consejos prácticos para {{destination}}',
        stepTipsDone_one: '{{count}} consejo',
        stepTipsDone_other: '{{count}} consejos',
        stepTickets: "Tus reservas",
        stepTicketsDone_one: "{{count}} añadida",
        stepTicketsDone_other: "{{count}} añadidas",
        ticketsUnplaced_one: "No hemos podido leer {{count}} documento: está guardado en Notas para que lo añadas desde Docs.",
        ticketsUnplaced_other: "No hemos podido leer {{count}} documentos: están guardados en Notas para que los añadas desde Docs.",
        dayStops_one: 'Día {{number}} · {{count}} parada',
        dayStops_other: 'Día {{number}} · {{count}} paradas',
        doneEmpty: 'Viaje creado — puedes añadir lugares cuando quieras desde la pestaña Llocs.',
        errorCredits: 'Sin créditos de IA — tu viaje se ha creado, pero no hemos podido generar sugerencias esta vez.',
        errorUnknown: 'Algo ha fallado generando las sugerencias — tu viaje se ha creado igualmente.',
        cta: 'Ver mi viaje',
      },
    },
  },
  birthDate: {
    day: "Día",
    month: "Mes",
    year: "Año",
  },
  import: {
    sidebarButton: 'Importar documento',
    title: 'Importar desde documentos',
    description: 'Sube un archivo de Word, PDF, Excel o texto con tu plan y extraeremos los lugares y el itinerario día a día. No se añade nada hasta que confirmes.',
    dropHint: 'Haz clic para elegir archivos',
    addMore: 'Añadir más archivos',
    analyze_one: 'Analizar {{count}} documento',
    analyze_other: 'Analizar {{count}} documentos',
    formats: 'PDF, Word, Excel, CSV o imágenes · hasta 10 archivos',
    extracting: 'Leyendo tus documentos…',
    docProgress: "Documento {{current}} de {{total}}",
    reviewHint: 'Elige qué añadir a tu viaje. Lo que ya existe nunca se modifica.',
    savedDocsNote: 'Documentos importados',
    language: {
      title: 'El documento está en {{document}}',
      hint: 'Tu viaje está en {{trip}}. Traduce lo que importas para que todo el viaje hable un solo idioma. Los nombres de los sitios no se tocan.',
      action: 'Traducir a {{trip}}',
      done: 'Contenido traducido al idioma del viaje',
      failed: 'No se ha podido traducir. Puedes añadirlo tal cual.',
    },
    placesSection_one: '{{count}} lugar',
    placesSection_other: '{{count}} lugares',
    daySection: 'Día {{number}}',
    daySectionNoNumber: 'Itinerario',
    activitiesSection_one: "{{count}} actividad",
    activitiesSection_other: "{{count}} actividades",
    packingCount_one: "{{count}} objeto de maleta",
    packingCount_other: "{{count}} objetos de maleta",
    flightsSection_one: '{{count}} vuelo',
    flightsSection_other: '{{count}} vuelos',
    hotelsSection_one: '{{count}} alojamiento',
    hotelsSection_other: '{{count}} alojamientos',
    nightsCount_one: '{{count}} noche',
    nightsCount_other: '{{count}} noches',
    bookingsSection_one: '{{count}} reserva',
    bookingsSection_other: '{{count}} reservas',
    tipsSection_one: '{{count}} consejo',
    tipsSection_other: '{{count}} consejos',
    packingSection: 'Maleta · {{section}}',
    expensesSection_one: '{{count}} gasto',
    expensesSection_other: '{{count}} gastos',
    addSelected_one: 'Añadir {{count}} elemento',
    addSelected_other: 'Añadir {{count}} elementos',
    added_one: 'Añadido {{count}} elemento',
    added_other: 'Añadidos {{count}} elementos',
    mapsQuotaWarning: 'Esta vez no hemos podido ubicar algunos lugares en el mapa, pero se han importado igualmente.',
    errors: {
      nothingFound: 'No hemos encontrado ningún lugar ni itinerario en ese documento.',
      extractFailed: 'No hemos podido leer ese documento — prueba con otro archivo.',
      insufficientCredits: 'Te has quedado sin créditos de IA.',
      rateLimited: "Estamos recibiendo muchas peticiones ahora mismo. Espera unos segundos e inténtalo de nuevo.",
      saveFailed: 'Algo ha fallado al añadir los elementos — inténtalo de nuevo.',
    },
  },
  trip: {
    editName: 'Haz clic para cambiar el nombre del viaje',
    renameFailed: 'No se pudo cambiar el nombre del viaje',
    destinations: {
      title: "Destinos", edit: "Cambiar destinos",
      hint: "Los sitios que visita el viaje, en orden, y cuántas noches en cada uno.",
      saved: "Destinos actualizados", failed: "No se han podido cambiar los destinos",
      moveUp: "Subir {{name}}", moveDown: "Bajar {{name}}",
    },
    dates: {
      title: 'Fechas del viaje', edit: 'Cambiar las fechas', confirm: 'Aplicar',
      saved: 'Fechas actualizadas', failed: 'No se han podido cambiar las fechas',
      willMove_one: 'El viaje se acorta. 1 parada del día {{from}} pasa al día {{to}}.',
      willMove_other: 'El viaje se acorta. {{count}} paradas del día {{from}} pasan al día {{to}}.',
      willLoseMeals_one: 'Se perderá 1 comida planificada en los días que desaparecen — las comidas se van con su día.',
      willLoseMeals_other: 'Se perderán {{count}} comidas planificadas en los días que desaparecen — las comidas se van con su día.',
      willLoseOutfits_one: "Se perderá la ropa prevista de 1 día que desaparece — sigue en la maleta.",
      willLoseOutfits_other: "Se perderá la ropa prevista de {{count}} días que desaparecen — sigue en la maleta.",
      willAdd_one: 'Se añade un día vacío al final.', willAdd_other: 'Se añaden {{count}} días vacíos al final.',
      noLoss_one: 'El viaje mantiene su día, en la fecha nueva.', noLoss_other: 'Los {{count}} días mantienen sus paradas, en las fechas nuevas.',
      bookingsOutside_one: '1 reserva queda fuera de las fechas nuevas', bookingsOutside_other: '{{count}} reservas quedan fuera de las fechas nuevas',
      bookingsKept: 'Conservan su fecha: un localizador es un hecho, así que no se mueve nada por ti.',
      aFlight: 'Vuelo',
    },
    nav: {
      itinerary: 'Itinerario', places: 'Lugares', map: 'Mapa',
      bookings: 'Reservas', expenses: 'Gastos', meals: 'Comidas', packing: 'Maleta', info: 'Consejos',
      plan: 'Plan', placesShort: 'Lugares', mapShort: 'Mapa',
      docsShort: 'Docs', money: 'Dinero', mealsShort: 'Comidas', packingShort: 'Maleta', infoShort: 'Consejos',
      notes: 'Notas', notesShort: 'Notas',
      services: 'Servicios', servicesShort: 'Servicios',
      gallery: 'Diario', galleryShort: 'Diario', album: 'Álbum',
      more: 'Más',
    },
    sidebar: {
      allTrips: 'Todos los viajes', sections: 'Secciones', documentation: 'Documentación', collapse: 'Contraer barra', expand: 'Expandir barra',
      nights_one: '{{count}} noche', nights_other: '{{count}} noches',
      flights_one: '{{count}} vuelo', flights_other: '{{count}} vuelos',
      people: '{{count}} personas',
      manage: 'Gestionar',
      workspace: 'Área de trabajo',
      travellers_one: 'viajero',
      travellers_other: 'viajeros',
      underway: 'En curso',
      tomorrow: 'Mañana',
      inDays: 'En {{count}} días',
      ready: '{{pct}}% listo',
      exportPdf: 'Exportar PDF',
      generating: 'Generando…',
      exportFailed: 'Error al generar el PDF',
    },
    cover: {"title": "Foto de portada", "hint": "Sale en la tarjeta y la cabecera del viaje. Encuadre 3:2.", "add": "Subir una foto", "remove": "Usar la portada automática", "cropTitle": "Encuadra la portada", "save": "Guardar portada", "saved": "Portada actualizada", "removed": "Vuelve la portada automática", "failed": "No se ha podido actualizar la portada", "unsupported": "Ese archivo no es una foto que podamos usar", "alt": "Portada del viaje", "changeAction": "Cambiar la portada"},
    contentLanguage: {
      title: 'Idioma del viaje',
      hint: 'El idioma en el que la asistente escribe el contenido del viaje: lugares, itinerario, consejos y maleta. Solo afecta al contenido nuevo; lo ya guardado se queda como está.',
      saved: 'Idioma del viaje actualizado',
      failed: 'No se pudo actualizar el idioma del viaje',
    },
    manage: { title: 'Gestionar viaje' },
    participants: {
      roles: { OWNER: 'Propietario', EDITOR: 'Editor', VIEWER: 'Lector' },
      title: 'Participantes del viaje',
      you: '(tú)',
      pending: 'Invitaciones pendientes',
      invite: 'Invitar a alguien por email',
      sendInvitation: 'Invitar',
      hint: 'Recibirá un email con un enlace para unirse. Los dos roles cuentan como viajeros: comparten gastos y tienen su propia maleta.',
      viewerHint: 'Solo el propietario del viaje puede invitar o eliminar viajeros.',
      roleEditor: 'Editor · viaja y edita',
      roleViewer: 'Solo lectura · viaja, no edita',
      remove: 'Quitar',
      cancelInvite: 'Cancelar',
      roleLabel: 'Rol: {{role}} · Caduca',
      age_one: "{{count}} año",
      age_other: "{{count}} años",
      placeholder: {
        addBirthDate: "Añadir fecha de nacimiento",
        editBirthDate: "Cambiar fecha de nacimiento",
        noAccount: 'Sin cuenta',
        addTitle: 'Añadir a alguien sin cuenta',
        addHint: 'Para quien aún no se ha registrado: puedes ponerle gastos, vuelos y cosas de la maleta a su nombre, y vincularlo a su cuenta más tarde.',
        namePlaceholder: 'Nombre',
        add: 'Añadir',
        link: 'Vincular a una cuenta',
        inviteHint: 'Mándale una invitación. Cuando la acepte, todo lo que está a su nombre pasa a su cuenta.',
        mergeHint: '¿Ya está en el viaje con su propia cuenta?',
        mergeSelect: 'Elige quién es',
        merge: 'Fusionar',
        confirmMergeTitle: '¿Fusionar a {{name}} con {{target}}?',
        confirmMergeBody: 'Todo lo asignado a {{name}} —gastos, deudas, vuelos y cosas de la maleta— pasa a {{target}}. No se puede deshacer.',
        invitationFor: 'para {{name}}',
        toast: {
          birthDateFailed: "No se ha podido guardar la fecha de nacimiento",
          added: '{{name}} añadido al viaje',
          addFailed: 'No se ha podido añadir',
          merged: 'Fusionado',
          mergeFailed: 'No se ha podido fusionar',
        },
      },
      toast: {
        invited: 'Invitación enviada',
        emailNotVerified: 'Verifica tu email antes de invitar a otros usuarios',
        inviteFailed: 'No se ha podido enviar la invitación',
        revoked: 'Invitación cancelada',
        revokeFailed: 'No se ha podido cancelar',
        removed: 'Participante eliminado',
        roleChanged: 'Rol actualizado',
        roleChangeFailed: 'No se ha podido actualizar el rol',
      },
    },
    notifications: {
      reminder_one: '{{count}} recordatorio próximo', reminder_other: '{{count}} recordatorios próximos',
      title: 'Recordatorios',
    },
    notFound: 'Viaje no encontrado',
    demo: {
      banner: 'Este es un viaje de ejemplo — siéntete libre de explorar todo.',
      deleteConfirm: '¿Eliminar este viaje de ejemplo?',
      deleteFailed: 'Error al eliminar el viaje de ejemplo',
    },
    tour: {
      start: 'Ver el tour',
      skip: 'Saltar',
      back: 'Atrás',
      next: 'Siguiente',
      finish: 'Entendido',
      steps: {
        importDoc: {
          title: "¿Ya tienes el viaje en un documento?",
          body: "Sube un Word, PDF o Excel — incluso tickets de vuelo u hotel — y extraemos los lugares, el itinerario, las reservas y los gastos por ti.",
        },
        welcome: {
          title: '¡Bienvenido a Gromly! 👋',
          body: 'Este es un viaje de ejemplo a Barcelona. Haz un tour rápido para ver todo lo que puedes hacer — puedes saltártelo cuando quieras.',
        },
        itinerary: {
          title: 'Planifica tu itinerario',
          body: 'Organiza tu viaje día a día: añade actividades, pon horarios y arrastra para reordenar.',
        },
        itineraryAi: {
          title: 'Te presentamos a gIA, en todas partes',
          body: 'Ahora gIA te acompaña en cada pantalla, acoplada aquí a la derecha. Se adapta a donde estés —itinerario, lugares, reservas, maleta o consejos—, así que solo tienes que desplegarla para pedirle ideas, un día entero o que reorganice cosas. Tu conversación te sigue al cambiar de pestaña.',
        },
        places: {
          title: 'Guarda lugares que visitar',
          body: 'Reúne restaurantes, monumentos y barrios por categoría — y la IA puede sugerirte nuevos lugares que encajen con tu viaje.',
        },
        map: {
          title: 'Míralo todo en el mapa',
          body: 'Tus lugares guardados y las actividades de cada día, todo en un mismo mapa.',
        },
        mapRoutes: {
          title: 'Las rutas en el mapa',
          body: 'Cambia a «Rutas» para ver todos los días seleccionados a la vez: tiempos de trayecto, transporte por tramo y «Optimizar con gIA» para reordenar las paradas de un día.',
        },
        bookings: {
          title: 'Guarda tus reservas',
          body: 'Ten vuelos, hoteles y entradas en un solo sitio. Pega una confirmación y la IA extrae los datos por ti.',
        },
        expenses: {
          title: 'Controla y divide gastos',
          body: 'Apunta lo que gastas, marca un presupuesto y divide gastos con tus compañeros de viaje.',
        },
        balances: {
          title: 'Quién debe a quién',
          body: 'Gromly compensa todos los gastos compartidos y te dice exactamente quién debe a quién — sin cálculos.',
        },
        packing: {
          title: 'Maleta',
          body: 'Listas de equipaje y documentos para no olvidarte de nada — la IA puede generarte la lista según tu destino y fechas.',
        },
        tips: {
          title: 'Consejos',
          body: 'Consejos locales de transporte, comida y seguridad — la IA puede generarlos a medida para tu destino.',
        },
        notes: {
          title: 'Notas',
          body: 'Un bloc compartido para ideas, enlaces y cualquier cosa que quieras recordar.',
        },
        gallery: {
          title: 'Galería',
          body: 'Sube las fotos del viaje y míralas organizadas por día.',
        },
        finish: {
          title: '¡Todo listo!',
          body: 'Ese es el tour. Explora sin miedo — este viaje de ejemplo es tuyo para practicar, y puedes eliminarlo cuando quieras empezar a planificar de verdad.',
        },
      },
    },
    share: {
      disable: 'Desactivar compartir', enable: 'Activar compartir', creating: 'Creando…',
      disabledToast: 'Compartir desactivado', enabledToast: '¡Enlace de compartir creado!',
      panelTitle: 'Enseñar el viaje a quien no va',
      panelHint: 'Un enlace que abre el viaje sin necesidad de cuenta. Quien lo abre no es un viajero: no entra en la división por persona, no tiene maleta y no cuenta en el número de viajeros. Elige qué se ve.',
      sectionsTitle: 'Qué enseña el link',
      sectionsHint: 'Este link se creó antes de que existieran estas opciones, así que sigue enseñando lo de siempre. Marca lo que quieras añadir.',
      photosWarning: 'Los enlaces de las fotos siguen funcionando una vez copiados, aunque vuelvas a desactivarlo.',
      diaryHint: 'Cada autor decide qué entradas salen. Los seguidores se apuntan por correo desde el enlace. Apagar el enlace los borra a todos.',
      section: {
        ITINERARY: 'Itinerario',
        NOTES: 'Notas de paradas y lugares',
        PLACES: 'Lugares guardados',
        MAP: 'Mapa',
        MEALS: 'Comidas',
        TIPS: 'Consejos',
        PHOTOS: 'Fotos',
        DIARY: 'Diario',
        BOOKINGS: 'Vuelos, alojamiento y reservas',
      },
    },
    story: {
      entry: 'Historia de Instagram',
      title: 'Historia de Instagram',
      upload: 'Subir una foto',
      background: 'Fondo',
      gradient: { paper: 'Crema', ink: 'Negro' },
      framingHint: "Arrastra para mover la foto y usa la rueda para ampliarla",
      statDays: 'Días', statStops: 'Paradas', statDistance: 'Distancia',
      download: 'Descargar', share: 'Compartir',
      hint: 'Guarda la imagen y súbela a tu historia — 1080 × 1920.',
      previewAlt: 'Vista previa de la historia',
      imageFailed: 'No se ha podido cargar esa imagen', exportFailed: 'No se ha podido crear la imagen',
    },
  },
  linkedDelete: { both: "Borrar las dos" },
  itinerary: {
    stopPhotos_one: '{{count}} foto de esta parada', stopPhotos_other: '{{count}} fotos de esta parada',
    // ADR-0039: a stop of the travellers' own, as agency staff see it.
    maskedStop: {
      title: "Plan de los viajeros",
      hint: "Es suyo: la agencia no ve qué es.",
    },
    deleteLinked: {
      title_one: "Esta parada es una comida planificada",
      title_other: "{{count}} de estas paradas son comidas planificadas",
      body_one: "¿Borrar también la comida de Comidas?",
      body_other: "¿Borrar también esas comidas de Comidas?",
      only_one: "Solo la parada",
      only_other: "Solo las paradas",
    },
    suggestTime: {
      use: 'usar',
      hint: 'Calculada desde la parada anterior y el trayecto entre ambas. Pulsa para usarla.',
      noTravel: 'Calculada desde la parada anterior. Todavía no cuenta el trayecto.',
    },
    schedule: {
      from: 'desde las',
      dayStart: 'El día empieza a las',
      setDayStart: 'Poner hora de inicio',
      clear: 'Volver a horas manuales',
      hint: 'Las horas salen de esta, de lo que dura cada parada y del trayecto entre ellas.',
      manual: 'Las horas de este día son las que escribiste tú.',
      estimated: 'estimada',
      noTravel: 'Falta contar los trayectos — calcúlalos y el día se recolocará.',
      overrun: 'No cabe antes de esta hora fija',
      locked: 'Hora fija',
      timeMode: 'Tipo de hora',
      modeAuto: 'Calculada',
      modeFixed: 'Fija',
      autoHint: 'Se ajusta sola según el orden, las duraciones y los trayectos.',
      fixedHint: 'No se mueve aunque reordenes el día.',
    },
    title: 'Itinerario',
    subtitle_one: '{{count}} día · {{nights}} noches',
    subtitle_other: '{{count}} días · {{nights}} noches',
    views: { list: 'Lista', timeline: 'Cronología' },
    addDay: 'Añadir día',
    heading: 'El plan',
    daysPlanned_one: '{{count}} día planificado',
    daysPlanned_other: '{{count}} días planificados',
    legend: { hasActivities: 'Con actividades', today: 'Hoy' },
    dayLabel: 'Día {{n}}',
    dayShort: 'D{{n}}',
    weather: {
      condition: { clear: 'Despejado', fair: 'Poco nuboso', partlyCloudy: 'Parcialmente nuboso', cloudy: 'Nublado', fog: 'Niebla', drizzle: 'Lluvia débil', rain: 'Lluvia', snow: 'Nieve', thunder: 'Tormenta' },
      typicalFor: 'típico de {{month}}',
      aria: '{{condition}}, máxima {{max}}°, mínima {{min}}°',
      ariaTypical: 'Típico de {{month}}: máxima {{max}}°, mínima {{min}}°',
      at: 'Medido en {{place}}',
      atTrip: 'Medido en {{place}} — el destino del viaje, no una parada de este día',
      tripDestination: 'destino del viaje',
      panel: {
        title: 'Hora a hora',
        subtitle: 'Cómo evoluciona el tiempo en cada día del viaje',
        open: 'Ver hora a hora',
        noHourly: 'El pronóstico horario sólo llega a unos 9 días vista.',
        noData: 'No hay datos del tiempo para este día.',
        blocksLegend: 'A más de ~3 días vista el pronóstico sólo da cuatro mediciones al día, y se muestran sueltas. La curva horaria completa aparece a medida que esos días se acercan.',
        beyondForecast: 'Más allá del pronóstico',
        precip: '{{mm}} mm',
        wind: '{{kmh}} km/h',
      },
    },
    modal: { addActivity: 'Añadir actividad', editActivity: 'Editar actividad', addToItinerary: 'Añadir al itinerario', addToDays: 'Añadir a {{count}} días', dayLabel: 'Día', addedToDay: 'Añadido al Día {{n}}', addedToDays: 'Añadido a {{count}} días', removedFromItinerary: 'Quitado del itinerario', itinerarySaved: 'Itinerario actualizado', unassignHint: 'Deselecciona un día para quitarlo del itinerario.', noDaysYet: 'Sin días de itinerario.', noDaysDesc: 'Añade días en la pestaña Itinerario primero.' },
    ai: { open: 'Abrir asistente IA', close: 'Cerrar asistente IA' },
    activities_one: '{{count}} actividad',
    activities_other: '{{count}} actividades',
    flight: { outbound: 'Ida', return: 'Vuelta' },
    fromBooking: 'Reserva',
    fromBookingHint: 'Viene de una reserva de la pestaña Reservas — edita la reserva y se actualizan todas las noches.',
    hotel: { checkIn: 'Check-in', checkOut: 'Check-out', night: 'Noche' },
    continuesFrom: 'Continúa desde',
    startFromPrev: { active: 'Inicio aquí', inactive: 'Empezar desde aquí', disable: 'Dejar de continuar desde el día anterior', lastOfPrevDay: 'Último lugar del día anterior' },
    optional: { badge: 'Opcional', label: 'Parada opcional', hint: 'Si el día se complica, te la puedes saltar sin problema.', mark: 'Marcar como opcional', unmark: 'Marcar como imprescindible' },
    openInMaps: 'Abrir en Google Maps',
    openBooking: 'Abrir enlace de reserva',
    delete: { title: '¿Eliminar actividad?', ariaLabel: 'Eliminar actividad', body: 'Esta acción no se puede deshacer.', bodyLocked: 'Esta actividad es el punto de inicio del día siguiente — al eliminarla también se quitará de ahí.' },
    bulk: { selected_one: '{{count}} seleccionada', selected_other: '{{count}} seleccionadas', delete: 'Eliminar selección', cancel: 'Cancelar', select: 'Seleccionar', move: 'Mover a…', moveTo: 'Mover al día', duplicate: 'Duplicar en…', duplicateTo: 'Duplicar en el día', deleting: 'Eliminando…' },
    stopCount_one: '{{count}} parada', stopCount_other: '{{count}} paradas',
    legs: { calculate_one: 'Tiempo de trayecto ({{count}} tramo)', calculate_other: 'Tiempos de trayecto ({{count}} tramos)' },
    move: {
      dropOnDay: 'Suelta en un día para moverla allí',
      releaseOnDay: 'Suelta para moverla al día {{day}} · {{date}}',
      confirmTitle_one: '¿Mover «{{title}}» al día {{day}}?', confirmTitle_other: '¿Mover {{count}} paradas al día {{day}}?',
      confirm: 'Mover',
      moved_one: 'Movida al día {{day}}', moved_other: '{{count}} paradas movidas al día {{day}}',
      duplicated_one: 'Copia creada', duplicated_other: '{{count}} copias creadas',
      failed: 'No se ha podido mover', duplicateFailed: 'No se ha podido duplicar',
      errorOrigin: 'La tarjeta «continúa desde» sigue al día anterior: no se puede mover sola.',
      errorStayNight: 'Una noche de alojamiento no tiene fecha propia: cambia las fechas de la reserva.',
      errorBookingCard: 'Una tarjeta generada por una reserva no se puede duplicar; duplica la reserva.',
    },
    form: {
      titleField: 'Título', titlePlaceholder: 'p.ej. Almuerzo en Alfama',
      yourTypes: 'Tus tipos', newType: '+ Nuevo tipo…', newTypeName: 'Nombre del tipo', newTypePlaceholder: 'p. ej. Snorkel, Cata de vinos',
      type: 'Tipo',
      startTime: 'Hora de inicio', duration: 'Duración', durationHours: 'h', durationMinutes: 'min',
      venueName: 'Nombre del lugar', zone: 'Zona / Barrio',
      bookingUrl: 'URL de reserva', notes: 'Notas',
      notesPlaceholder: 'Solo efectivo, reservar con antelación...',
      update: 'Actualizar', addActivity: 'Añadir actividad', saveAndAddAnother: 'Guardar y añadir otra',
      day: 'Día',
      dayBookingHint: 'Viene de una reserva — cambiar el día también mueve la reserva.',
      dayStayHint: 'Una tarjeta por noche — cambia las fechas del alojamiento en Reservas.',
      fromPlaces: 'Desde lugares guardados', filterPlaces: 'Filtrar lugares…', noMatchPlaces: 'Sin resultados',
    },
    types: {
      RESTAURANT: 'Restaurante', CAFE: 'Café', MONUMENT: 'Monumento', VIEWPOINT: 'Mirador',
      NEIGHBORHOOD: 'Barrio', PARK: 'Parque', SHOP: 'Tienda', EXPERIENCE: 'Experiencia',
      TRANSPORT: 'Transporte', PARKING: 'Parking', BEACH: 'Playa', NATURE: 'Naturaleza', ACCOMMODATION: 'Alojamiento', OTHER: 'Otro',
    },
    toast: {
      added: '¡Actividad añadida!', addedWithPlace: 'Actividad añadida · {{name}} guardado en Sitios',
      updated: 'Actividad actualizada',
      deleted: 'Actividad eliminada', failed: 'Error al guardar la actividad',
      loadFailed: 'Error al cargar el itinerario', removedSuccess: 'Actividad eliminada',
      movedToDay: 'Movida al día {{n}}',
      optimizeFailed: 'Error al optimizar con IA', optimizeNoResult: 'No se pudo optimizar la ruta',
      optimizeApplied: 'Ruta optimizada aplicada', reorderFailed: 'No se pudo guardar el nuevo orden',
    },
    undo: { action: 'Deshacer', undoLabel: 'Deshacer (Ctrl+Z)', redoLabel: 'Rehacer (Ctrl+Shift+Z)', undone: 'Deshecho', failed: 'No se pudo deshacer — se ha recargado el plan', reordered: 'Orden cambiado', legMode: 'Modo de transporte cambiado' },
    empty: {
      noDays: 'Sin días aún',
      noDaysDesc: 'Los días se generan automáticamente desde las fechas del viaje. Para añadir más días, amplía la fecha de fin en la configuración del viaje.',
      clickDay: 'Haz clic en un día del viaje para ver las actividades',
      noEvents: 'Sin eventos. Añade días y actividades primero.',
      noActivities: 'Sin actividades aún',
      addStop: 'Añadir parada', planWithAi: 'Planificar con gIA', fromSaved: 'De mis sitios guardados',
      planPrompt: 'Planifícame el día {{n}}: elige las paradas, ponlas en un orden sensato y dale una hora a cada una.',
    },
    dow: { mon: 'Lun', tue: 'Mar', wed: 'Mié', thu: 'Jue', fri: 'Vie', sat: 'Sáb', sun: 'Dom' },
    dayUnit_one: 'DÍA', dayUnit_other: 'DÍAS',
  },
  venues: {
    title: 'Lugares para visitar',
    categories: {
      RESTAURANT: 'Restaurantes', CAFE: 'Cafeterías', ATTRACTION: 'Atracciones',
      VIEWPOINT: 'Miradores', NEIGHBORHOOD: 'Barrios', PARK: 'Parques',
      SHOP: 'Tiendas', EXPERIENCE: 'Experiencias', TRANSPORT_HUB: 'Transporte',
      BEACH: 'Playas', NATURE: 'Naturaleza', PARKING: 'Parkings', OTHER: 'Otros',
    },
    filter: { all: 'Todos', toVisit: 'Por visitar', visited: 'Visitados', day: 'Día', scheduled: 'Con día', unscheduled: 'Sin día' },
    noDaySection: 'Sin día asignado',
    progress: '{{visited}} de {{total}} visitados',
    placesCount_one: 'LUGAR', placesCount_other: 'LUGARES',
    addPlace: 'Añadir lugar', editPlace: 'Editar lugar', addToItinerary: 'Añadir al itinerario',
    addToDay: 'Añadir al día',
    mapView: 'Mapa', maps: 'Maps', book: 'Reservar',
    markVisited: 'Marcar como visitado', markUnvisited: 'Desmarcar visitado', visited: 'Visitado',
    viewOnMaps: 'Ver en Google Maps',
    openNow: 'Abierto ahora', closedNow: 'Cerrado ahora', fullSchedule: 'Ver horario completo', closedDay: 'Cerrado',
    hoursDisclaimer: 'El horario puede no estar 100% actualizado — confírmalo con el local.',
    showDetails: 'Ver fotos y valoraciones', showDetailsSource: '· vía Google',
    detailsUnavailable: 'No hay información adicional de este sitio.',
    deleted: 'Sitio eliminado',
    form: {
      name: 'Nombre', category: 'Categoría', address: 'Dirección',
      priceInfo: 'Precio', bookingUrl: 'URL de reserva', notes: 'Notas',
      searchPlace: 'Buscar un lugar o dirección…',
      namePlaceholder: 'p.ej. Casa Marieta', pricePlaceholder: 'p.ej. ~20€/persona', notesPlaceholder: 'Solo efectivo, reservar con 2 semanas…',
      customCategory: 'Tipo de lugar', customCategoryPlaceholder: 'p. ej. Cueva, Bodega, Aguas termales',
      yourCategories: 'Tus categorías', newCategory: '+ Nueva categoría…',
    },
    bulk: { addToDay: 'Añadir a un día…', scheduled_one: 'Añadido al día {{n}}', scheduled_other: '{{count}} sitios añadidos al día {{n}}' },
    noMatch: 'Ningún lugar coincide con este filtro.',
    day_one: 'Día {{days}}', day_other: 'Días {{days}}',
    empty: { title: 'Construye tu lista de lugares', body: 'Guarda cada restaurante, monumento, café y mirador. Márcalos como visitados mientras exploras y enlaza directamente con Google Maps.', addFirst: 'Añadir primer lugar', askAi: 'Pedir sugerencias a la IA' },
    delete: {
      title: 'Eliminar lugar',
      body: '¿Seguro que quieres eliminar este lugar? Esta acción no se puede deshacer.',
      confirm: 'Eliminar',
      withStops_one: 'También es una parada del día {{days}} — esa parada se va con él.',
      withStops_other: 'También es una parada de los días {{days}} — esas paradas se van con él.',
    },
    toast: {
      loadFailed: 'Error al cargar los lugares',
      deleted: 'Lugar eliminado',
      added: '{{name}} añadido a tus lugares',
      addFailed: 'Error al añadir el lugar',
      updated: 'Lugar actualizado',
      saveFailed: 'Error al guardar el lugar',
      suggestionAdded_one: '{{count}} lugar nuevo añadido',
      suggestionAdded_other: '{{count}} lugares nuevos añadidos',
      suggestionFailed: 'No se pudieron generar más sugerencias',
      suggestionError: 'Error al generar sugerencias',
    },
  },
  map: {
    routeError: 'No se ha podido calcular la ruta', stopsCount_one: '{{count}} parada', stopsCount_other: '{{count}} paradas',
    travelMode: { WALKING: 'Caminar', DRIVING: 'Coche', BICYCLING: 'Bici', TRANSIT: 'Transporte', FERRY: 'Ferri', FLIGHT: 'Vuelo', TRANSFER: 'Traslado', ferryLeg: '{{duration}} en ferri', unavailable: 'No disponible para este tramo', fallbackToast_one: 'Ese modo de transporte no tiene ruta en este tramo — cambiado a uno que sí', fallbackToast_other: 'Sin ruta en ese modo de transporte en {{count}} tramos — cambiados a uno que sí' },
    allPlaces: 'Todos los lugares',
    dayLabel: 'Día {{n}}',
    showOnlyCategory: 'Ver solo {{label}}',
    destinationChip: { showWholeTrip: 'Ver todo el viaje', showOnly: 'Ver sólo {{name}}' },
    removeCategoryFilter: 'Quitar el filtro {{label}}',
    showAllCategories: 'Ver todas las categorías',
    collapsePanel: 'Contraer panel', expandPanel: 'Expandir panel',
    quota: { title: 'Límite mensual de mapas alcanzado', body: 'Los lugares, rutas y búsquedas quedan en pausa hasta que se renueve el límite.', bodyWithDate: 'Los lugares, rutas y búsquedas quedan en pausa hasta que se renueve el límite el {{date}}.', hint: 'El resto del viaje sigue funcionando con normalidad.' },
    unavailable: { title: 'No se ha podido cargar el mapa', body: 'Google Maps no ha respondido. Revisa la conexión y vuelve a intentarlo en un momento.' },
    dayFilter: 'Día',
    showAll: 'Mostrar todo', hideAll: 'Ocultar todo',
    showAllDays: "Mostrar todos los días",
    optionalStops: 'Opcionales',
    optionalStopsHint: 'Oculta las paradas opcionales. La ruta dibujada sigue pasando por ellas: el tramo atenuado es lo que te ahorrarías saltándotelas.',
    dayNotCalculated: "No se ha podido calcular la ruta de este día",
    scrollLeft: 'Desplazar a la izquierda', scrollRight: 'Desplazar a la derecha',
    searchPlaces: 'Buscar lugares…',
    legFromTo: 'Trayecto de {{from}} a {{to}}',
    calculating: 'Calculando…',
    routes: 'Rutas',
    daysCount_one: '{{count}} día', daysCount_other: '{{count}} días',
    noDaysSelected: 'Ningún día seleccionado',
    savedPlaces: 'Lugares guardados', savedPlacesHint: 'Mostrar los lugares guardados que aún no están en ninguna ruta',
    showOnMap: 'Ver {{name}} en el mapa',
    places: 'Lugares', fullRoute: 'Ruta completa',
    calculatingRoutes: 'Calculando rutas…',
    optimizing: 'Optimizando…',
    optimizeWith: 'Optimizar con',
    optimize: 'Optimizar',
    openInMaps: 'Abrir en Maps',
    recenter: 'Recentrar mapa',
    savePlaceModal: 'Guardar lugar',
    addToItineraryModal: 'Añadir al itinerario',
    aiOptimizePrompt: 'Optimiza el orden de las paradas de hoy para minimizar desplazamientos.',
    aiOptimizeHintPrefix: 'Indicaciones del usuario (prioritarias sobre los criterios genéricos)',
    aiHint: {
      title: 'Indicaciones para la IA',
      subtitle: 'Opcional. Indica horarios, comidas o preferencias específicas.',
      placeholder: 'Ej. La Sagrada Família por la mañana, cenar tapas hacia las 21h…',
    },
    center: 'Centrar', save: 'Guardar',
    aiProposalTitle: 'Sugerencia de ruta IA', proposedOrder: 'Orden propuesto',
    filter: 'Filtro',
    locatingPlaces: 'Localizando tus lugares…', locationsToFind: 'lugares por encontrar',
    noDaysYet: 'Aún no hay días en el itinerario', addDaysFirst: 'Añade días en la pestaña Itinerario primero.',
    loadError: 'Error al cargar Google Maps. Comprueba la API key.',
    collapseStops: 'Colapsar paradas', expandStops: 'Expandir paradas', tapToSeeStops: 'Toca para ver las paradas',
  },
  bookings: {
    expenses: { paid: 'Pagado por esta reserva', add: 'Añadir gasto' },
    types: { TRANSPORT: 'Transporte', EVENT: 'Evento', ACTIVITY: 'Actividad', RESTAURANT: 'Restaurante', OTHER: 'Otro' },
    title: 'Reservas y entradas', subtitle: 'Vuelos, hoteles, transporte y entradas',
    sections: { flights: 'Vuelos', hotels: 'Hoteles y alojamiento', transport: 'Transporte', events: 'Eventos y entradas' },
    form: {
      direction: 'Dirección', outbound: '→ Ida', return: '← Vuelta',
      from: 'Origen (IATA)', to: 'Destino (IATA)', departure: 'Salida', arrival: 'Llegada',
      flightNumber: 'Número de vuelo', airline: 'Aerolínea',
      bookingRef: 'Referencia de reserva', notes: 'Notas',
      hotelName: 'Nombre del hotel', address: 'Dirección', checkIn: 'Entrada', checkOut: 'Salida',
      currency: 'Moneda', bookingUrl: 'URL de reserva',
      category: 'Categoría', title: 'Título', provider: 'Proveedor / Empresa',
      date: 'Fecha', startTime: 'Hora de inicio', endTime: 'Hora de fin',
      startDate: 'Fecha de inicio', endDate: 'Fecha de fin',
      endDateHint: 'Solo si dura varios días',
      endDateBeforeStart: 'La fecha de fin es anterior a la de inicio',
      venue: 'Lugar / Local', price: 'Precio', confirmed: 'Confirmado',
      documents: 'Documentos (PDFs, imágenes, correos)',
      saveChanges: 'Guardar cambios', addFlight: 'Añadir vuelo', addHotel: 'Añadir hotel', addBooking: 'Añadir reserva',
      legs: 'Tramos', addLeg: 'Añadir tramo', passengers: 'Pasajeros',
      searchPlace: 'Buscar un lugar o dirección…',
      extractWithAi: 'Rellenar con IA', extracting: 'Leyendo documento…', addWithAi: 'Añadir con IA',
      addWithAiTitle: 'Añadir con IA',
      addWithAiExplanation: 'Sube un billete, tarjeta de embarque o confirmación de reserva (PDF, foto o el propio correo guardado como .eml) y lo leemos por ti, adjuntos incluidos: fechas, horarios, número de vuelo, referencias de reserva y más se rellenan automáticamente. Podrás revisarlo todo antes de guardar.',
      addWithAiDropTitle: 'Suelta tu archivo aquí', addWithAiDropSubtitle: 'o haz clic para buscarlo — PDF, imagen o correo (.eml)',
      unreviewedTitle_one: 'Queda 1 vuelo por revisar', unreviewedTitle_other: 'Quedan {{count}} vuelos por revisar',
      unreviewedBody_one: 'Se ha leído del documento pero aún no está guardado. Si cierras ahora, no se añadirá.',
      unreviewedBody_other: 'Se han leído del documento pero aún no están guardados. Si cierras ahora, no se añadirán.',
      unreviewedDiscard: 'Descartar', unreviewedKeep: 'Seguir revisando',
      stepIndicator: 'Paso {{current}} de {{total}}', saveAndContinue: 'Guardar y continuar',
      legNumber: 'Tramo {{n}}', removeLeg: 'Eliminar tramo', arrivalBeforeDeparture: 'llegada ≤ salida',
      hotelNamePlaceholder: 'El Gran Hotel',
      bookingTitlePlaceholder: 'p. ej. Renfe AVE Madrid–Barcelona',
      venuePlaceholder: 'Bernabéu, Teatro Real…',
    },
    reminder: {
      startsIn: 'Empieza en {{delay}}', endsIn: 'Termina en {{delay}}',
      endTitle: 'Fin · {{title}}',
      label: 'Recordatorio antes del evento', minutes: 'minutos', hours: 'horas',
      warnNoTime: 'Establece una hora de inicio para activar el recordatorio',
    },
    docs: {
      title: 'Documentos', upload: 'Subir archivo',
      dropHere: 'Suelta un PDF, imagen o correo (.eml) aquí, o haz clic para subir',
      attachFile: 'Adjunta ticket, PDF, captura o correo', addMore: 'Añadir más archivos',
      deleteTitle: '¿Eliminar documento?', deleteConfirm: '¿Eliminar "{{name}}"? Esta acción no se puede deshacer.',
    },
    deleteItem: {
      flightTitle: '¿Eliminar vuelo?', hotelTitle: '¿Eliminar hotel?', bookingTitle: '¿Eliminar reserva?',
    },
    empty: {
      noFlights: 'Sin vuelos añadidos', noHotels: 'Sin hoteles añadidos',
      noTransport: 'Añade trenes, buses, ferris o coches de alquiler',
      noEvents: 'Añade conciertos, teatro, deportes, tours, restaurantes…',
      addOne: 'Añadir',
    },
    notifications: {
      blocked: 'Las notificaciones están bloqueadas. Actívalas en la configuración del navegador para recibir recordatorios.',
      prompt: 'Activa las notificaciones del navegador para recibir recordatorios antes de tus reservas.',
      enableBtn: 'Activar',
    },
    status: { outbound: 'Ida', return: 'Vuelta', confirmed: 'Confirmado', pending: 'Pendiente' },
    modal: {
      editFlight: 'Editar vuelo', addFlight: 'Añadir vuelo',
      editHotel: 'Editar hotel', addHotel: 'Añadir hotel',
      editBooking: 'Editar reserva', addBooking: 'Añadir reserva',
    },
    toast: {
      loadFailed: 'Error al cargar reservas', saveFailed: 'Error al guardar',
      flightDeleted: 'Vuelo eliminado', hotelDeleted: 'Hotel eliminado', bookingDeleted: 'Reserva eliminada',
      flightAdded: 'Vuelo añadido', flightUpdated: 'Vuelo actualizado',
      hotelAdded: 'Hotel añadido', hotelUpdated: 'Hotel actualizado',
      bookingAdded: 'Reserva añadida', bookingUpdated: 'Reserva actualizada',
      fileDeleted: 'Archivo eliminado', uploadFailed: 'Error al subir',
      uploadFileFailed: 'No se pudo subir {{name}}',
      filesUploaded_one: '{{count}} archivo subido', filesUploaded_other: '{{count}} archivos subidos',
      extractSuccess: 'Datos rellenados — revísalos antes de guardar', extractFailed: 'No se pudo leer el documento',
      extractNoMatch: 'No se pudo relacionar a: {{names}}. Añádelos manualmente.',
    },
    yourTickets: 'Tus billetes',
    bookingsCount_one: 'RESERVA', bookingsCount_other: 'RESERVAS',
    durationDays_one: '{{count}} día', durationDays_other: '{{count}} días',
    view: { sections: 'Secciones', timeline: 'Cronología' },
    timeline: { dayLabel: 'Día {{n}}', noTickets: 'Sin billetes', ongoingDay: 'día {{n}}/{{total}}', ongoingEnd: 'último día' },
    ticket: {
      from: 'Origen', to: 'Destino', direct: 'Directo',
      layover_one: '{{count}} escala', layover_other: '{{count}} escalas',
      layoverAt: 'Escala en {{airport}}',
    },
  },
  expenses: {
    reservationGroups: { FLIGHT: 'Vuelos', HOTEL: 'Alojamientos', BOOKING: 'Otras reservas' },
    travellersCount_one: '{{count}} VIAJERO', travellersCount_other: '{{count}} VIAJEROS',
    title: 'Gastos',
    ledger: 'El libro de cuentas',
    redistribute: {
      title: 'Nuevos miembros en el viaje',
      desc_one: '{{names}} se unió después de registrar gastos. ¿Repartir también con él/ella el {{count}} gasto compartido anterior?',
      desc_other: '{{names}} se unió después de registrar gastos. ¿Repartir también con él/ella los {{count}} gastos compartidos anteriores?',
      apply: 'Repartir con ellos',
      dismiss: 'Ahora no',
      done_one: 'Se ha repartido {{count}} gasto',
      done_other: 'Se han repartido {{count}} gastos',
      failed: 'No se han podido repartir los gastos',
    },
    stats: { totalSpent: 'Total gastado', expenses: 'Gastos', biggest: 'El mayor' },
    subtitle_one: '{{count}} registro', subtitle_other: '{{count}} registros',
    addExpense: 'Añadir gasto', editExpense: 'Editar gasto',
    delete: { link: 'Eliminar gasto', title: '¿Eliminar este gasto?' },
    expenseCount_one: '{{count}} gasto', expenseCount_other: '{{count}} gastos',
    splits_one: '{{count}} división', splits_other: '{{count}} divisiones',
    chart: { totalSpent: 'Total gastado', total: 'total' },
    groupBy: { all: 'Todos', byCategory: 'Por categoría' },
    scan: {
      button: 'Escanear un ticket',
      aiButton: 'Escanear con IA',
      scanning: 'Leyendo…',
      success: 'Ticket leído — revisa los datos',
      failed: 'No se ha podido leer el archivo. Rellénalo a mano.',
      title: 'Escanear gastos con IA',
      explanation: 'Sube un ticket, o una captura de tu banco o monedero con varios movimientos — cada gasto encontrado vuelve aquí para que lo revises.',
      dropTitle: 'Suelta aquí un ticket o una captura',
      dropSubtitle: 'Imágenes o PDF · hasta {{count}} archivos',
      reviewHint_one: '{{count}} gasto detectado. Desmarca lo que no quieras y toca una fila para editarla.',
      reviewHint_other: '{{count}} gastos detectados. Desmarca los que no quieras y toca una fila para editarla.',
      noDescription: 'Sin descripción',
      noRate: 'sin tasa',
      rateFailed: 'No se ha podido obtener la tasa de hoy de {{currencies}}.',
      fixRow: 'Completa antes el gasto marcado.',
      include: 'Incluir este gasto',
      exclude: 'Dejar fuera este gasto',
      selectedTotal_one: '{{count}} seleccionado',
      selectedTotal_other: '{{count}} seleccionados',
      addSelected_one: 'Añadir {{count}} gasto',
      addSelected_other: 'Añadir {{count}} gastos',
      savedCount_one: '{{count}} gasto añadido',
      savedCount_other: '{{count}} gastos añadidos',
      savedFailed_one: 'No se ha podido guardar {{count}} gasto',
      savedFailed_other: 'No se han podido guardar {{count}} gastos',
    },
    form: {
      reservation: 'Reserva vinculada', reservationNone: '— Ninguna —',
      description: 'Descripción', descriptionPlaceholder: 'p.ej. Reserva de hotel',
      category: 'Categoría', payment: 'Pago', amount: 'Importe',
      currency: 'Moneda', date: 'Fecha', status: 'Estado',
      splitBetween: 'Dividir entre', perPerson: '{{currency}} {{amount}} / persona',
      notes: 'Notas', saveChanges: 'Guardar cambios', addExpense: 'Añadir gasto',
      paidBy: 'Pagado por', you: 'Tú', noCurrencies: 'Sin resultados',
      conversion: {
        title: 'Convertir a {{currency}}',
        loading: 'Cargando…', refresh: 'Actualizar tipo',
        manual: 'Tipo no disponible — introdúcelo manualmente.',
        asOf: 'Tipo del {{date}}',
      },
    },
    categories: {
      ACCOMMODATION: 'Alojamiento', FLIGHTS: 'Vuelos', FOOD: 'Comida',
      ACTIVITIES: 'Actividades', TRANSPORT: 'Transporte',
      FUEL: 'Gasolina', PARKING: 'Parking', CASH: 'Efectivo', OTHER: 'Otros',
    },
    payment: { CARD: 'Tarjeta', CASH: 'Efectivo', TRANSFER: 'Transferencia' },
    status: { PAID: 'Pagado', PENDING: 'Pendiente' },
    settlement: {
      title: 'Plan de liquidación', even: 'Todos estáis al día',
      allDone: 'Todas las transferencias confirmadas', pending: '{{pending}} de {{total}} pendientes',
      allEven: '¡Todos estáis al día — no hacen falta transferencias!',
      confirmed: 'Confirmado', settle: 'Liquidar', undo: 'Deshacer',
      onlySelf: 'Añade más participantes al viaje para dividir gastos y ver quién debe qué.',
      payIn: 'Pagar en', markSettled: 'Marcar liquidada',
      rateUnavailable: 'Tipo de cambio no disponible',
      paidAs: 'Pagado como {{amount}} {{currency}}',
    },
    budget: {
      title: 'Presupuestos', manage: 'Presupuestos', set: 'Fijar presupuestos', edit: 'Editar',
      empty: 'Sin presupuestos',
      emptyDesc: 'Fija topes de gasto por total, día, categoría o persona y recibe un aviso antes de pasarte.',
      total: 'Total del viaje', daily: 'Por día',
      categorySection: 'Por categoría', personSection: 'Por persona',
      tripSection: 'Límites de todo el viaje',
      tripSectionHint: 'Estos topes aplican a todo el viaje, no por día.',
      dailySection: 'Tope diario',
      dailyHint: 'Un tope para cada día — te avisamos cuando un día se acerca o se pasa.',
      noLimit: 'Sin límite',
      leftAmount: 'Quedan {{amount}}', overAmount: 'Pasado por {{amount}}', atLimit: 'Límite alcanzado',
      worstDay: 'Peor día: {{amount}}',
      daysOver_one: '{{count}} día por encima del tope', daysOver_other: '{{count}} días por encima del tope',
      save: 'Guardar presupuestos', saved: 'Presupuestos guardados', failed: 'No se pudieron guardar los presupuestos',
      alertsTitle: 'Alertas de presupuesto',
      overToast: 'Atención — acabas de pasarte del presupuesto de {{label}}',
      warnToast: 'Te estás acercando al presupuesto de {{label}}',
    },
    debts: {
      title: 'Deudas liquidadas', recalculate: 'Recalcular',
      showSettled: 'Mostrar liquidadas ({{count}})', hideSettled: 'Ocultar liquidadas ({{count}})',
    },
    empty: {
      title: 'Controla los gastos compartidos',
      desc: 'Registra cada gasto y divídelo entre los viajeros. La app calcula quién debe qué y te permite liquidar deudas con un toque.',
      addFirst: 'Añadir primer gasto',
    },
    toast: {
      settled: '¡Deuda liquidada!', recalculated: 'Deudas recalculadas', deleted: 'Gasto eliminado',
      updated: '¡Gasto actualizado!', added: '¡Gasto añadido!',
      failedUpdate: 'Error al actualizar el gasto', failedAdd: 'Error al añadir el gasto',
      selectParticipant: 'Selecciona al menos un participante', loadFailed: 'Error al cargar los gastos',
      rateRequired: 'Introduce un tipo de cambio válido',
    },
    filters: {
      button: 'Filtrar', clear: 'Limpiar', day: 'Día', category: 'Categoría',
      paidBy: 'Pagado por', remove: 'Quitar {{filter}}',
      showing_one: '{{count}} gasto', showing_other: '{{count}} gastos',
    },
    table: {
      all: 'TODOS', noFilter: 'Ningún gasto coincide con el filtro',
      date: 'Fecha', item: 'Concepto', category: 'Categoría', paidBy: 'Pagado por', split: 'División', amount: 'Importe',
      editRow: 'Editar {{description}}',
      linkedReservation: 'Vinculado a una reserva',
    },
    spendingByPerson: 'Gasto por persona',
    byPerson: {
      traveller: 'Viajero', paid: 'Pagado', share: 'Su parte', balance: 'Balance',
      formerTraveller: 'Viajero que ya no está',
      hint: 'Pagado es lo que puso. Su parte es lo que le toca según el reparto.',
    },
    spendingByDay: 'Gasto por día',
    byCategory: 'Por categoría',
    whoOwesWhom: 'Quién debe a quién',
    settledCount: 'Liquidado · {{count}}',
    baseCurrency: {
      title: 'Moneda base',
      desc: 'Los balances y el presupuesto se muestran en esta moneda; los gastos en otras monedas se convierten a ella. Solo puedes cambiarla antes de añadir ningún gasto.',
      edit: 'Cambiar moneda base',
      saving: 'Guardando…',
      saved: 'Moneda base actualizada',
      failed: 'No se pudo actualizar la moneda base',
    },
  },
  info: {
    deleteTip: 'Eliminar consejo',
    tipsSectionTitle: 'Tips',
    title: 'Consejos de viaje', subtitle: 'Consejos según tu destino',
    tips: 'Consejos de viaje',
    heading: 'Consejos de viaje',
    quickSuggestions: 'Sugerencias rápidas',
    acceptAndAdd: 'Aceptar y añadir',
    discard: 'Descartar',
    saving: 'Guardando…',
    tipsProposalLabel: 'Propuesta · {{count}} tips',
    tipsAdded_one: '{{count}} tip añadido',
    tipsAdded_other: '{{count}} tips añadidos',
    loadFailed: 'Error al cargar los consejos',
    tipsGenerateFailed: 'Error al generar tips',
    tipsSaveFailed: 'Error al guardar tips',
    tipsAiDefault: 'Dame los tips más útiles para este destino.',
    tipsAiPlaceholder: 'Ej: tips para alguien que va por primera vez…',
    tipsAiMorePlaceholder: 'Pide más tips o ajustes…',
    addTipCategoryPlaceholder: 'Categoría',
    addTipContentPlaceholder: 'Contenido del tip…',
    addTipBtn: 'Añadir tip',
    addTipLabel: 'Añadir un tip',
    suggestedCategories: 'Categorías sugeridas',
    tipCategories: ['Transporte', 'Visados y entrada', 'Dinero y cajeros', 'Seguridad', 'Idioma', 'Costumbres locales', 'Tarjeta SIM', 'Clima'] as string[],
    tipsPrompts: ['Tips esenciales para este destino', 'Transporte público y taxis', 'Dinero, propinas y cajeros', 'Seguridad y scams habituales', 'Frases útiles en idioma local', 'Costumbres locales'] as string[],
  },
  meals: {
    savedFlash: "Guardado",
    title: 'Comidas',
    subtitle: 'Qué se come cada día, y qué hay que comprar para ello.',
    slot: {
      BREAKFAST: 'Desayuno', LUNCH: 'Comida', SNACK: 'Merienda',
      DINNER: 'Cena', OTHER: 'Otra',
    },
    addTo: 'Añadir {{slot}}',
    addAtPlace: 'En un restaurante',
    pickSaved: 'Elige uno guardado',
    placeholder: 'Pasta con salmón, cena en Dill…',
    notesPlaceholder: 'Notas (opcional)',
    linkVenue: 'Enlazar un sitio',
    editMeal: 'Editar comida',
    noVenue: 'Sin sitio',
    searchPlace: 'Buscar un restaurante o café…',
    venueHint: 'Elige un restaurante o café guardado, o búscalo: se guardará en Lugares.',
    emptyDay: 'Nada planificado',
    ingredients: {
      title: 'Ingredientes', add: 'Añadir ingrediente',
      namePlaceholder: 'Salmón, pasta…', amountPlaceholder: 'Cant.', amountLabel: 'Cantidad',
      unit: 'Unidad', remove: 'Quitar {{name}}',
      unitMismatch: 'Este producto ya se cuenta en otra unidad',
      editAmount: 'Cambiar cantidad de {{name}}',
    },
    units: { u: 'ud.', g: 'g', kg: 'kg', ml: 'ml', l: 'l' },
    pantry: {
      title: 'Despensa',
      hint: 'Lo comprado, menos lo que se comieron las comidas de días pasados.',
      left: 'quedan {{amount}}', missing: 'faltan {{amount}}',
      planned: 'plan {{amount}}', bought: 'comprado {{amount}}', pending: '{{amount}} en la lista',
      addMissingFor: 'Añadir lo que falta de {{name}} a la lista',
      added: '{{name}} añadido a la lista',
      addShort: 'Añadir', onList: 'En la lista',
    },
    grocery: {
      setAmount: 'cantidad',
      amountLabel: 'Cantidad a comprar', unitLabel: 'Unidad de compra',
      title: 'Lista de la compra',
      add: 'Añadir a la lista',
      placeholder: 'Salmón fresco',
      forMeal: 'para {{title}}',
      empty: 'Todavía no hay nada que comprar.',
      emptyHint: 'Apunta lo que necesitan las comidas y táchalo en la tienda.',
      bought_one: '{{count}} en la cesta',
      bought_other: '{{count}} en la cesta',
      clearBought: 'Vaciar lo comprado',
      cleared_one: '{{count}} artículo eliminado',
      cleared_other: '{{count}} artículos eliminados',
      collapse: 'Ocultar la lista de la compra',
      expand: 'Mostrar la lista de la compra',
    },
    toast: {
      created: 'Comida añadida',
      deleted: 'Comida eliminada',
      saveFailed: 'No se ha podido guardar la comida',
      deleteFailed: 'No se ha podido eliminar la comida',
      groceryFailed: 'No se ha podido guardar la lista de la compra',
      stopFailed: "No se ha podido actualizar la parada del itinerario",
    },
    // ADR-0024: a meal linked to a stop of its day.
    stop: {
      pick: "Vincular a una parada…",
      create: "Añadir al itinerario",
      timePlaceholder: "Hora",
      hint: "Vinculada a una parada, el título y el sitio son los mismos en las dos.",
      linked: "En el itinerario",
      linkedAt: "En el itinerario a las {{time}}",
      otherDay: "Su parada está en el día {{day}}",
      unlink: "Desvincular",
      badge: "Plan",
    },
    deleteLinked: {
      title: "Esta comida es una parada del itinerario",
      body: "¿Borrar también la parada?",
      only: "Solo la comida",
    },
  },
  packing: {
    outfits: {
      heading: "Ropa por día",
      hint: "Planifica qué te pondrás cada día con la ropa de tu maleta. Separa el día en momentos sólo si te ayuda (playa, cena…).",
      piecePlaceholder: "Escribe o elige una prenda…",
      addNew: "Añadir «{{text}}» a tu maleta",
      addNewTo: "Añadir «{{text}}» a {{section}}",
      sectionEmpty: "No queda nada en esta sección — escribe una prenda para añadirla.",
      fromSection: "De la sección",
      suitcaseEmpty: "Aún no hay ropa en tu maleta — escribe una prenda para añadirla.",
      addPiece: "Añadir ropa",
      addGroup: "Separar por momentos del día",
      groupPrompt: "¿Para qué momento?",
      groupPresets: ["Playa", "Cena", "Deporte", "Excursión", "Salir de noche"],
      dragHint: "Arrástrala a otro momento",
      allDay: "Todo el día",
      groupPlaceholder: "Otro momento…",
      groupName: "Nombre del momento",
      renameGroup: "Renombrar el momento",
      deleteGroup: "Quitar el momento",
      deleteGroupHint: "Su ropa vuelve a «Todo el día»",
      removePiece: "Quitar {{text}} de este día",
      packed: "En la maleta",
      notPacked: "Aún no está en la maleta",
      pieceCount_one: "{{count}} prenda",
      pieceCount_other: "{{count}} prendas",
      emptyDay: "Nada previsto",
      loadFailed: "No se pudo cargar la ropa por día",
      addFailed: "No se pudo añadir la prenda",
    },
    addSuggested_one: 'Añadir {{count}} sección',
    addSuggested_other: 'Añadir {{count}} secciones',
    addSectionFailed: 'No se pudo añadir la sección',
    scope: {
      mine: 'Mía', common: 'Común', someone: 'Alguien',
    },
    sharing: {
      on: 'La ve el grupo', off: 'Solo yo',
      onHint: 'Los demás ven tu maleta. Pulsa para guardártela.',
      offHint: 'Solo tú ves tu maleta. Pulsa para compartirla con el grupo.',
      nowShared: 'Tu maleta ya la ve el grupo',
      nowPrivate: 'Tu maleta ya es privada',
      failed: 'No se pudo cambiar quién ve tu maleta',
    },
    copy: {
      button: 'Copiar de otro viaje',
      title: 'Copiar apartados de maleta',
      pickTrip: '¿De qué viaje quieres copiar?',
      noTrips: 'Aún no tienes otros viajes de los que copiar.',
      backToTrips: 'Elegir otro viaje',
      pickSections: 'Apartados a copiar',
      items_one: '{{count}} cosa',
      items_other: '{{count}} cosas',
      selectAll: 'Seleccionar todo',
      clearAll: 'Quitar todo',
      nothingToCopy: 'Ese viaje aún no tiene apartados de maleta con cosas dentro.',
      mergeHint: 'Los apartados con el mismo nombre se fusionan y lo que ya tengas no se duplica.',
      confirm_one: 'Copiar {{count}} apartado',
      confirm_other: 'Copiar {{count}} apartados',
      copying: 'Copiando…',
      done_one: '{{count}} cosa añadida',
      done_other: '{{count}} cosas añadidas',
      nothingNew: 'Ya tenías todo eso en tu lista',
      loadFailed: 'No se pudo cargar la maleta de ese viaje',
      failed: 'No se pudieron copiar los apartados',
    },
    assignee: { label: 'Quién lo lleva', nobody: 'Nadie aún' },
    readOnlyHint: 'La maleta de otra persona: puedes verla, pero no cambiarla.',
    emptySection: 'Aquí todavía no hay nada',
    completedProgress: '{{done}}/{{total}} completado · {{pct}}%',
    title: 'Maleta', subtitle: 'Tu checklist de equipaje',
    checklists: 'Checklists pre-viaje',
    heading: 'Maleta',
    quickSuggestions: 'Sugerencias rápidas',
    acceptAndAdd: 'Aceptar y añadir',
    discard: 'Descartar',
    saving: 'Guardando…',
    packingProposalLabel: 'Propuesta · {{sections}} secciones · {{items}} items',
    sectionsAdded_one: '{{count}} sección añadida a tu checklist',
    sectionsAdded_other: '{{count}} secciones añadidas a tu checklist',
    sectionRemoved: 'Sección eliminada',
    loadFailed: 'Error al cargar la maleta',
    packingGenerateFailed: 'Error al generar la lista de equipaje',
    packingGenerateSaveFailed: 'Error al guardar la lista de equipaje',
    packingAiDefault: 'Genera una lista de equipaje completa y personalizada.',
    packingAiPlaceholder: 'Ej: Para mujer, viaje de 5 días en verano…',
    packingAiMorePlaceholder: 'Pide más secciones o ajustes…',
    suggestedSections: 'Secciones sugeridas',
    newSectionPlaceholder: 'Nueva sección (ej: Documentos, Reservas…)',
    addSection: 'Sección',
    addSectionLabel: 'Añadir una sección',
    addItemPlaceholder: 'Añadir elemento…',
    addItemBtn: 'Añadir',
    done: 'Hecho ✓',
    packingPrompts: ['Para hombre', 'Para mujer', 'Familia con niños', 'Viaje de negocios', 'Mochilero', 'Playa / verano', 'Montaña / senderismo'] as string[],
    defaultSectionNames: ['Documentos', 'Ropa', 'Neceser', 'Electrónica', 'Medicamentos', 'Reservas', 'Dinero'] as string[],
    sectionAiButton: 'Generar elementos con IA',
    sectionAiPlaceholder: 'Opcional: cuántos días, clima, actividades previstas…',
    sectionAiGenerate: 'Generar',
    sectionAiPrompt: 'Genera SOLO elementos nuevos para añadir a la sección de la lista de equipaje "{{title}}" de este viaje. Contexto adicional del usuario: {{info}}. No repitas elementos que ya están en la lista: {{existing}}. Devuelve una única sección llamada exactamente "{{title}}" con solo los elementos nuevos.',
    sectionAiNoExtraInfo: 'ninguno especificado',
    sectionAiNoExistingItems: 'ninguno todavía',
    sectionAiAdded_one: 'Añadido {{count}} elemento a "{{title}}"',
    sectionAiAdded_other: 'Añadidos {{count}} elementos a "{{title}}"',
    sectionAiEmpty: 'La IA no ha sugerido elementos nuevos para esta sección',
    sectionAiFailed: 'No se han podido generar los elementos — inténtalo de nuevo',
    dragHandle: 'Arrastra para reordenar',
    reorderFailed: 'No se ha podido guardar el nuevo orden',
    deleteSection: 'Eliminar sección',
    deleteItem: 'Eliminar elemento',
    editItem: 'Pulsa para editar',
    renameItemFailed: 'No se ha podido renombrar el elemento',
    checkItem: 'Marcar como preparado',
    uncheckItem: 'Marcar como no preparado',
  },
  shared: {
    viewOnly: 'Viaje compartido (solo lectura)',
    noDiary: 'Aún no hay nada escrito en el diario.',
    follow: { title: 'Seguir este viaje', hintAccount: 'Te avisaremos en la app cuando el grupo escriba en el diario.', hintEmail: 'Recibe un correo cuando el grupo escriba en el diario.', follow: 'Seguir', following: 'Siguiendo', followed: 'Sigues este viaje', unfollowed: 'Ya no sigues este viaje', error: 'Algo ha fallado. Inténtalo de nuevo.', emailPlaceholder: 'Tu correo', subscribe: 'Avisarme', checkInbox: 'Revisa tu correo para confirmarlo.', confirmed: '¡Hecho! Te escribiremos cuando haya algo nuevo.', unsubscribed: 'No recibirás más correos de este viaje.', linkExpired: 'Este enlace ya no funciona.' },
    notFoundTitle: 'Viaje no encontrado',
    notFoundDesc: 'Este enlace no es válido o el propietario ha desactivado la opción de compartir.',
    nights_one: '{{count}} noche', nights_other: '{{count}} noches',
    traveller_one: '{{count}} viajero', traveller_other: '{{count}} viajeros',
    sections: {
      diary: 'Diario',
      flights: 'Vuelos', accommodation: 'Alojamiento', itinerary: 'Itinerario', about: 'Sobre el viaje',
      places: 'Lugares', map: 'Mapa', travel: 'Viaje',
      tips: 'Consejos', photos: 'Fotos', meals: 'Comidas', bookings: 'Reservas',
    },
    footer: 'Compartido con Gromly · Solo lectura',
    outbound: 'Ida', return: 'Vuelta', noActivities: 'Sin actividades planificadas',
    optional: 'Opcional',
    noPlaces: 'No hay lugares guardados.', noTips: 'Todavía no hay consejos.', noPhotos: 'Todavía no hay fotos.', noBookings: 'Todavía no hay nada reservado.',
    openInMaps: 'Abrir en Google Maps',
    map: {
      allPlaces: 'Todos los lugares', dayByDay: 'Día a día', dayLabel: 'Día {{n}}',
      unavailable: 'Mapa no disponible', noRouteYet: 'La ruta de este día todavía no está calculada.',
    },
  },
  account: {
    storage: { title: "Almacenamiento", photos: "Fotos", used: "{{used}} de {{quota}}", full: "Tu espacio para fotos está lleno. Borra alguna para poder subir nuevas." },
    avatar: { change: "Cambiar foto", add: "Añadir foto", remove: "Quitar foto", cropTitle: "Encuadra tu foto", zoom: "Zoom", save: "Guardar foto", saved: "Foto de perfil actualizada", removed: "Foto de perfil eliminada", failed: "No se ha podido actualizar tu foto", unsupported: "Ese archivo no es una foto que podamos usar" },
    birthDate: "Fecha de nacimiento", birthDateHint: "Solo la ves tú. Tus viajes solo ven tu edad, para avisarte de tarifas y ventajas por edad.", birthDateSaved: "Fecha de nacimiento guardada", birthDateSaveFailed: "No se ha podido guardar tu fecha de nacimiento",
    nationality: "Nacionalidad", nationalitySaveFailed: "No se pudo actualizar la nacionalidad",
    title: 'Cuenta',
    subtitle: 'Gestiona tu perfil y preferencias',
    profile: 'Perfil',
    memberSince: 'Miembro desde',
    credits: 'Créditos',
    tripCredits: 'Créditos de viaje',
    aiCredits: 'Créditos IA',
    plan: { title: "Plan", gift: "Regalo de Gromly", free: "Gratis", proUntil: "PRO hasta el {{date}}", manage: "Gestionar suscripción", inStore: "Gestiónala en {{store}}", upgrade: "Hazte PRO", restore: "Restaurar compras", restored: "Compras restauradas", nothing: "No hay compras que restaurar" },
    security: 'Seguridad',
    changePassword: {
      title: 'Cambiar contraseña',
      rowHint: 'Actualiza la contraseña con la que entras',
      setTitle: 'Poner una contraseña',
      setHint: 'Tu cuenta aún no tiene contraseña',
      setLinkSent: 'Te hemos enviado un enlace para poner una contraseña.',
      setLinkFailed: 'No pudimos enviar el enlace. Inténtalo en unos minutos.',
      current: 'Contraseña actual',
      new: 'Nueva contraseña',
      confirm: 'Repite la nueva contraseña',
      signsOutOthers: 'Aquí seguirás dentro, pero se cerrará la sesión en el resto de dispositivos.',
      submit: 'Cambiar contraseña',
      success: 'Contraseña cambiada.',
      wrongCurrent: 'Esa no es tu contraseña actual.',
      unchanged: 'La nueva contraseña es la misma que la actual.',
      googleAccount: 'Esta cuenta entra con Google. Usa el enlace del email para poner una contraseña.',
      failed: 'No pudimos cambiar tu contraseña. Inténtalo de nuevo.',
    },
    twoFactor: 'Autenticación de dos factores',
    enabled: 'Activado',
    notEnabled: 'No activado',
    data: 'Datos y privacidad',
    exportData: 'Exportar mis datos',
    exportDataDesc: 'Descarga una copia de todos tus datos',
    danger: 'Zona de peligro',
    signOut: 'Cerrar sesión',
    deleteAccount: 'Eliminar cuenta',
    deleteAccountDesc: 'Elimina permanentemente tu cuenta y todos tus datos',
    deleteConfirmTitle: 'Eliminar cuenta',
    deleteConfirmSubtitle: 'Esta acción es permanente',
    deleteConfirmBody: 'Todos tus viajes, gastos, reservas y datos personales serán eliminados permanentemente. Esta acción no se puede deshacer.',
    deleting: 'Eliminando…',
    deletePermanently: 'Eliminar permanentemente',
    saveFirst: '¿Quieres guardar tus datos primero?',
    exportFailed: 'Error al exportar los datos. Por favor, inténtalo de nuevo.',
    deleteFailed: 'Error al eliminar la cuenta. Por favor, inténtalo de nuevo.',
  },
  docs: {
    hero: {
      title: 'Documentación de Gromly',
      subtitle: 'Todo lo que necesitas saber para planificar, colaborar y viajar con Gromly.',
      back: 'Volver al panel',
    },
    sidebar: { sections: 'Secciones' },
    footer: { title: '¿Listo para planificar?', subtitle: 'Vuelve a tu panel y crea tu primer viaje.', cta: 'Ir al panel' },
    itinerary: {
      title: 'Itinerario', subtitle: 'Planifica tus días, hora a hora',
      p1: 'El itinerario es el corazón de tu viaje. Añade actividades a cada día, reordénalas arrastrándolas, y cada día nuevo continúa automáticamente desde donde terminó el anterior.',
      feat_addDay_label: 'Añadir día', feat_addDay_desc: 'Haz clic en "Añadir día" para crear un nuevo día. Las fechas se asignan automáticamente desde la fecha de inicio del viaje.',
      feat_drag_label: 'Arrastrar y soltar', feat_drag_desc: 'Reordena actividades dentro de un día arrastrando el asa.',
      feat_ai_label: 'Planificación con IA', feat_ai_desc: 'Haz clic en el botón de IA para abrir el chat. Pídele que añada actividades, sugiera qué visitar o mueva cosas.',
      tip1: 'Cambia entre las vistas Lista y Cronología con el selector del encabezado. La vista Cronología fusiona vuelos, hoteles y actividades en un único feed cronológico.',
      step1: 'Haz clic en "Añadir día" para crear tu primer día.',
      step2: 'Haz clic en "+ Añadir actividad" para añadir actividades al día.',
      step3: 'Rellena el título, el tipo (Restaurante, Monumento, etc.) y los detalles opcionales.',
      step4: 'Arrastra las actividades para reordenarlas dentro del día.',
    },
    places: {
      title: 'Lugares', subtitle: 'Tu lista de deseos personal para el destino',
      p1: 'Lugares es tu lista curada de sitios que visitar: restaurantes que probar, monumentos que ver, barrios que explorar, tiendas que visitar. Todo organizado por categoría.',
      feat_add_label: 'Añadir lugar', feat_add_desc: 'Usa el botón "+ Añadir lugar" o pídele a la IA que lo añada con enriquecimiento automático de Google Maps.',
      feat_visited_label: 'Marcar como visitado', feat_visited_desc: 'Toca el check en la tarjeta del lugar una vez que hayas estado. Los lugares visitados quedan en gris pero se conservan en tu lista.',
      feat_ai_label: 'Recomendaciones IA', feat_ai_desc: 'Abre el chat de IA y pregunta "Dame 5 restaurantes en el casco antiguo". Los añadirá directamente a tu lista.',
      tip1: 'Los lugares añadidos aquí aparecen automáticamente como opciones de pin en la pestaña Mapa. Puedes vincular un lugar directamente a una actividad del itinerario con el botón "Añadir al itinerario".',
    },
    map: {
      title: 'Mapa', subtitle: 'Visualiza rutas y optimiza tu día',
      p1: 'La pestaña Mapa muestra todos tus lugares guardados como pins. Selecciona un día en el desplegable para ver solo las actividades de ese día con una ruta trazada entre ellos.',
      feat_route_label: 'Ruta del día', feat_route_desc: 'Selecciona un día para ver una ruta conectada entre todas las actividades en orden. Toca un pin para ver los detalles.',
      feat_reorder_label: 'Reordenar paradas', feat_reorder_desc: 'En el panel de ruta, arrastra las paradas para cambiar su orden. La ruta en el mapa se actualiza en tiempo real.',
      feat_ai_label: 'Optimizar con gIA', feat_ai_desc: 'Toca "Optimizar con gIA" para que la IA reordene tus paradas geográficamente y minimice los desplazamientos.',
      tip1: 'En móvil, el panel de ruta sube desde la parte inferior como una hoja. Deslízalo hacia abajo para ocultarlo y obtener una vista de mapa completa.',
    },
    bookings: {
      title: 'Reservas', subtitle: 'Vuelos, hoteles, transporte y entradas — todo en un lugar',
      p1: 'Reservas centraliza todas las reservas de tu viaje: vuelos de ida y vuelta, check-ins de hotel, tramos de transporte (tren, bus, taxi) y entradas a eventos o actividades.',
      feat_flights_label: 'Vuelos', feat_flights_desc: 'Añade vuelos de ida y vuelta con aerolínea, número de vuelo, aeropuertos y referencia de reserva.',
      feat_hotels_label: 'Hoteles', feat_hotels_desc: 'Registra tu alojamiento con fechas de entrada y salida, dirección y URL de reserva.',
      feat_bookings_label: 'Reservas y entradas', feat_bookings_desc: 'Añade cualquier otra reserva: teatro, partido de fútbol, entrada a museo, billete de bus — con fecha, lugar y referencia.',
      feat_docs_label: 'Adjuntar documentos', feat_docs_desc: 'Sube PDFs, capturas, fotos o el propio correo de confirmación (.eml) directamente a una reserva. Se almacenan de forma segura en la nube.',
      tip1: 'Guarda el correo de confirmación como .eml y súbelo tal cual: la IA lee el mensaje y los billetes que lleve adjuntos, y lo tienes accesible sin conexión. La app mostrará un recordatorio 48 horas antes de cada vuelo u hotel.',
      warning1: 'Las subidas de documentos requieren que Cloudflare R2 esté configurado en el servidor. Contacta con tu administrador si el botón de subida está desactivado.',
    },
    expenses: {
      title: 'Gastos y presupuesto', subtitle: 'Controla los gastos y liquida deudas automáticamente',
      p1: 'La pestaña de Gastos es un rastreador completo de gastos en grupo. Registra qué se gastó, quién pagó, cómo se reparte y deja que la app calcule la forma más sencilla de liquidar.',
      feat_add_label: 'Añadir gasto', feat_add_desc: 'Registra quién pagó, el importe, la divisa, la categoría (Alojamiento, Comida, Transporte…) y cómo dividirlo.',
      feat_settle_label: 'Liquidación automática', feat_settle_desc: 'Haz clic en "Recalcular" para obtener el conjunto mínimo de pagos que liquida todas las deudas.',
      feat_debt_label: 'Liquidar deuda', feat_debt_desc: 'Una vez pagada una deuda en la vida real, toca "Liquidar" para marcarla como hecha. Las deudas liquidadas se conservan como referencia.',
      feat_budget_label: 'Control de presupuesto', feat_budget_desc: 'Toca el icono de lápiz en la tarjeta de Presupuesto para establecer un presupuesto total. Una barra de progreso muestra cuánto has usado por categoría.',
      tip1: 'La barra de presupuesto se vuelve ámbar al llegar al 80% y roja al superarlo. Establécelo al inicio del viaje para saber siempre dónde estás.',
      step1: 'Abre Gastos y haz clic en "Añadir gasto".', step2: 'Selecciona quién pagó y el importe.',
      step3: 'Elige cómo dividir: a partes iguales o importes personalizados.',
      step4: 'Tras añadir varios gastos, haz clic en "Recalcular" para obtener el plan de liquidación.',
      step5: 'Cuando se realice un pago, toca "Liquidar" para cerrar la deuda.',
    },
    info: {
      title: 'Info y consejos', subtitle: 'Consejos, checklists y conocimiento local',
      p1: 'Info y Consejos tiene dos secciones: un tablero libre de consejos organizado por categoría (Transporte, Comida, Cultura, Dinero…) y checklists pre-viaje para hacer la maleta y prepararse.',
      feat_tips_label: 'Consejos', feat_tips_desc: 'Añade consejos cortos por categoría. Ideal para notas como "El metro cierra a medianoche" o "Reserva restaurantes con 2 semanas de antelación".',
      feat_checklists_label: 'Checklists', feat_checklists_desc: 'Crea secciones de checklist (Documentos, Ropa, Electrónica…) y añade elementos a cada una. Márcalos al hacer la maleta.',
      feat_ai_label: 'Lista de maleta con IA', feat_ai_desc: 'Haz clic en "Generar con IA" para obtener una lista de equipaje personalizada según tu destino, duración, época y actividades planificadas.',
      tip1: 'La lista de maleta con IA se genera como secciones de checklist para que puedas editarla, añadir o eliminar elementos después. Es un punto de partida, no una lista fija.',
      step1: 'Añade una sección de checklist (p. ej. "Documentos") con el campo de texto de abajo.',
      step2: 'Escribe los elementos uno a uno y pulsa Enter para añadirlos.',
      step3: 'O haz clic en "Generar con IA" para crear automáticamente una lista de equipaje completa.',
      step4: 'Al hacer la maleta, marca los elementos. La barra de progreso de arriba indica el avance.',
    },
    ai: {
      title: 'Asistente IA', subtitle: 'Tu compañero de viaje inteligente',
      p1: 'El asistente de IA es consciente del contexto: conoce tu destino, las fechas del viaje y lo que ya hay en tu viaje. Funciona de forma diferente según la pestaña en la que estés.',
      feat_places_label: 'Modo Lugares', feat_places_desc: 'Escribe "Añade la Sagrada Família a mis lugares" y la encontrará en Google Maps, rellenará la dirección y creará el lugar automáticamente.',
      feat_itinerary_label: 'Modo Itinerario', feat_itinerary_desc: 'Pídele que añada actividades a días y franjas horarias concretas, o que mueva actividades existentes. Conoce tu itinerario actual.',
      feat_route_label: 'Modo Ruta', feat_route_desc: 'En la pestaña Mapa, pídele que reordene las paradas del día seleccionado para minimizar el tiempo de desplazamiento entre zonas.',
      feat_packing_label: 'Modo Maleta', feat_packing_desc: 'En Info y Consejos, genera una lista de equipaje completa adaptada a tu destino, época y tipo de actividades.',
      tip1: 'Habla con la IA en cualquier idioma: responderá en el idioma que uses. Sé específico: "Añade 3 bares de tapas cerca del Barrio Gótico para cenar" funciona mejor que "Añade restaurantes".',
      warning1: 'La IA requiere una clave de API de OpenAI configurada en el servidor. Si el botón del chat de IA está desactivado o da error, pide a tu administrador que compruebe la clave.',
    },
    sharing: {
      title: 'Compartir viaje', subtitle: 'Permite que cualquiera vea tu viaje sin tener cuenta',
      p1: 'La función Compartir viaje genera un enlace público único que permite a cualquiera — incluso sin cuenta — ver tu viaje en modo de solo lectura: itinerario, vuelos, hoteles y notas.',
      feat_enable_label: 'Activar compartir', feat_enable_desc: 'En la barra lateral del viaje, haz clic en "Compartir viaje" y luego en "Activar compartir". Se genera inmediatamente una URL única.',
      feat_copy_label: 'Copiar enlace', feat_copy_desc: 'Copia el enlace y envíalo a familiares o amigos. Pueden ver el itinerario completo pero no editar nada.',
      feat_disable_label: 'Desactivar compartir', feat_disable_desc: 'Haz clic en "Desactivar compartir" en cualquier momento para invalidar el enlace. Quien tenga la URL antigua verá una página "No encontrado".',
      tip1: 'La vista compartida es una página limpia y adaptada al móvil que no requiere inicio de sesión. Perfecta para enviarle el itinerario a un familiar que quiera seguir tu viaje.',
      warning1: 'Solo el propietario del viaje puede activar o desactivar el compartir. Los participantes con roles EDITOR o VIEWER no pueden gestionar el enlace.',
    },
    participants: {
      title: 'Participantes', subtitle: 'Invita y gestiona tu grupo de viaje',
      p1: 'Invita a co-viajeros para colaborar en el viaje. Cada participante tiene un rol que controla lo que puede hacer.',
      feat_invite_label: 'Invitar por correo', feat_invite_desc: 'El invitado debe tener ya una cuenta. Introduce su correo y elige un rol.',
      feat_editor_label: 'Rol EDITOR', feat_editor_desc: 'Puede añadir, editar y eliminar contenido: actividades, lugares, gastos, reservas, consejos y checklists.',
      feat_viewer_label: 'Rol VIEWER', feat_viewer_desc: 'Acceso de solo lectura. Puede verlo todo pero no hacer cambios. Ideal para alguien que quiere seguir el plan.',
      tip1: 'Solo el propietario puede invitar participantes, cambiar su rol o eliminarlos. El propietario también es el único que puede eliminar el viaje completo.',
      step1: 'En la barra lateral del viaje, haz clic en el botón de participantes (muestra avatares y número de miembros). En móvil, toca el icono de personas en la cabecera del viaje.',
      step2: 'Haz clic en "Invitar participante" e introduce la dirección de correo.',
      step3: 'Elige EDITOR (puede editar) o VIEWER (solo lectura).',
      step4: 'El participante verá el viaje en su panel inmediatamente.',
    },
    notifications: {
      title: 'Notificaciones', subtitle: 'Recordatorios en la app para eventos próximos',
      p1: 'La app muestra recordatorios cuando la salida de un vuelo o el check-in de un hotel está en las próximas 48 horas. No necesita configuración: funciona automáticamente.',
      feat_flights_label: 'Recordatorios de vuelo', feat_flights_desc: 'Se muestran 48h antes de la salida. Urgente (rojo) dentro de las 12 horas.',
      feat_hotels_label: 'Recordatorios de hotel', feat_hotels_desc: 'Se muestran 48h antes del check-in. Urgente (rojo) dentro de las 12 horas.',
      feat_where_label: 'Dónde encontrarlos', feat_where_desc: 'Escritorio: panel ámbar en la barra lateral del viaje. Móvil: insignia roja en la pestaña Reservas de la barra de navegación inferior.',
      tip1: 'Los recordatorios se calculan a partir de tus vuelos y hoteles en la pestaña Reservas. Asegúrate de añadir las horas de salida reales para recibir alertas precisas.',
    },
    community: {
      title: 'Explorar comunidad', subtitle: 'Descubre, valora y clona viajes de otros viajeros',
      p1: 'La sección Explorar es un feed público de viajes compartidos por la comunidad Gromly. Busca destinos, descubre itinerarios de viajeros reales y clona cualquier viaje como punto de partida.',
      feat_browse_label: 'Navegar y buscar', feat_browse_desc: 'Filtra viajes por destino o duración, y ordena por Más recientes, Mejor valorados o Más usados. Usa la barra de búsqueda para un destino concreto.',
      feat_clone_label: 'Clonar un viaje', feat_clone_desc: 'Haz clic en "Usar este itinerario" en cualquier viaje de la comunidad para crear una copia completa en tu panel. El clon es independiente: tus ediciones no afectan al original.',
      feat_rate_label: 'Valorar viajes', feat_rate_desc: 'Deja una valoración de 1 a 5 estrellas en cualquier viaje publicado. Las valoraciones ayudan a destacar los mejores itinerarios.',
      feat_follow_label: 'Seguir viajeros', feat_follow_desc: 'Sigue a otros usuarios para filtrar el feed de la comunidad y ver solo sus viajes. Usa la pestaña "Siguiendo" para ver sus últimas publicaciones.',
      tip1: 'Para publicar tu propio viaje, ve a tu Panel, abre el menú del viaje (tres puntos) y haz clic en "Compartir con la comunidad". El viaje aparecerá en Explorar inmediatamente.',
      step1: 'Ve a Explorar desde la barra de navegación superior.',
      step2: 'Usa la barra de búsqueda u opciones de ordenación para encontrar viajes.',
      step3: 'Haz clic en una tarjeta de viaje para ver el itinerario completo.',
      step4: 'Haz clic en "Usar este itinerario" para clonarlo en tu panel.',
    },
    account: {
      title: 'Cuenta y seguridad', subtitle: '2FA, controles de privacidad y tus datos',
      p1: 'La configuración de tu cuenta está en el menú de usuario (esquina superior derecha). Desde allí puedes gestionar la autenticación de dos factores, descargar tus datos y eliminar tu cuenta.',
      feat_2fa_label: 'Autenticación de dos factores', feat_2fa_desc: 'Haz clic en "Seguridad" en el menú de usuario para configurar 2FA. Escanea el código QR con Google Authenticator, Authy o cualquier app TOTP.',
      feat_export_label: 'Descargar mis datos', feat_export_desc: 'Haz clic en "Descargar mis datos" en el menú de usuario para exportar todos tus datos personales en formato JSON (RGPD Art. 20 — portabilidad).',
      feat_delete_label: 'Eliminar cuenta', feat_delete_desc: 'Haz clic en "Eliminar cuenta" en el menú de usuario para eliminar permanentemente tu cuenta y todos los datos asociados. Esta acción no se puede deshacer.',
      tip1: 'Recomendamos activar 2FA: protege tu cuenta aunque tu contraseña se vea comprometida. Usa cualquier app compatible con TOTP: Google Authenticator, Authy, 1Password, etc.',
      warning1: 'Eliminar tu cuenta es permanente e irreversible. Se eliminarán todos tus viajes, gastos, reservas y documentos. Descarga tus datos antes si quieres conservar una copia.',
    },
    pwa: {
      title: 'Instalar como app (PWA)', subtitle: 'Usa Gromly sin conexión en cualquier dispositivo',
      p1: 'Gromly es una Progressive Web App (PWA). Puedes instalarla en tu móvil o escritorio y usarla como una app nativa, incluso sin conexión a internet.',
      feat_ios_label: 'Instalar en iOS', feat_ios_desc: 'Abre Gromly en Safari → toca el botón Compartir → "Añadir a la pantalla de inicio". Listo.',
      feat_android_label: 'Instalar en Android', feat_android_desc: 'Abre en Chrome → toca el menú de tres puntos → "Añadir a la pantalla de inicio" o "Instalar app".',
      feat_desktop_label: 'Instalar en escritorio', feat_desktop_desc: 'En Chrome o Edge, busca el icono de instalación (➕) en la barra de direcciones y haz clic.',
      tip1: 'Gromly guarda en caché tus viajes, itinerario y reservas para que carguen al instante incluso sin conexión. Consultarlos funciona sin conexión; añadir o editar cualquier cosa sigue necesitando conexión.',
    },
  },
  installPrompt: {
    title: 'Instala Gromly',
    subtitle: 'Añádela a tu pantalla de inicio para un acceso rápido a pantalla completa.',
    install: 'Instalar',
    iosIntro: 'Para instalarla en tu iPhone:',
    iosStep1: 'Toca el botón Compartir',
    iosStep2: 'Elige «Añadir a pantalla de inicio»',
  },
  maps: {
    quotaExceeded: 'Has alcanzado el límite de mapas de este mes. Se reinicia el {{date}}.',
  },
  ai: {
    deleteActivity: 'Eliminar actividad',
    venueNotes: {
      title: 'Reescribir las notas de {{name}}', titleNew: 'Notas para {{name}}',
      before: 'Ahora', after: 'Propuesta', emptied: '(notas vacías)',
    },
    deletePlaces_one: 'Eliminar lugar',
    deletePlaces_other: 'Eliminar {{count}} lugares',
    deleteAllPlaces_one: 'Vaciar la lista de lugares ({{count}} lugar)',
    deleteAllPlaces_other: 'Vaciar la lista de lugares ({{count}} lugares)',
    deleteTakesStops_one: 'También quita {{count}} parada del itinerario',
    deleteTakesStops_other: 'También quita {{count}} paradas del itinerario',
    deleteExpenses_one: 'Eliminar gasto',
    deleteExpenses_other: 'Eliminar {{count}} gastos',
    deleteAllExpenses_one: 'Vaciar el libro de cuentas ({{count}} gasto)',
    deleteAllExpenses_other: 'Vaciar el libro de cuentas ({{count}} gastos)',
    assistant: 'Asistente IA',
    name: 'gIA',
    expand: 'Abrir asistente',
    collapse: 'Contraer asistente',
    saveFailed: 'No se pudo guardar',
    someNotSaved: 'Algunas propuestas no se pudieron guardar',
    error: 'Lo siento, ha ocurrido un error. Inténtalo de nuevo.',
    clearConversation: 'Limpiar conversación',
    expenseSplitHint: 'Pagas tú; se reparte a partes iguales. Edita el detalle en Gastos.',
    proposals_one: '{{count}} propuesta',
    proposals_other: '{{count}} propuestas',
    saving: 'Guardando…',
    op: {
      tripDates: {
        title: 'Nuevas fechas: {{from}} → {{to}}',
        addedDays_one: 'Se añade {{count}} día',
        addedDays_other: 'Se añaden {{count}} días',
        removedDays_one: 'Se quita {{count}} día',
        removedDays_other: 'Se quitan {{count}} días',
        movedStops_one: '{{count}} parada pasa al día {{day}}',
        movedStops_other: '{{count}} paradas pasan al día {{day}}',
        removedMeals_one: 'Se pierde {{count}} comida planificada',
        removedMeals_other: 'Se pierden {{count}} comidas planificadas',
        removedOutfitDays_one: 'Se pierde la ropa prevista de {{count}} día',
        removedOutfitDays_other: 'Se pierde la ropa prevista de {{count}} días',
        outOfRange_one: '{{count}} reserva queda fuera de las nuevas fechas',
        outOfRange_other: '{{count}} reservas quedan fuera de las nuevas fechas',
      },
      settleDebt: {
        title: '{{from}} ha pagado a {{to}} {{amount}}',
      },
      outfitAdd: {
        title: 'Llevar {{item}} el día {{day}}',
      },
      ingredientAdd: {
        title: 'Añadir {{amount}} {{unit}} de {{name}} a «{{meal}}»',
      },
      mealStop: {
        title: 'Poner «{{meal}}» como parada del día {{day}}',
      },
      duplicate: {
        title_one: 'Copiar {{count}} parada al día {{day}}',
        title_other: 'Copiar {{count}} paradas al día {{day}}',
      },
      item: '– {{text}}',
    },
    cards: {
      empty: '(vacío)',
      field: {
        title: 'Título',
        notes: 'Notas',
        startTime: 'Hora',
        durationMins: 'Duración (min)',
        name: 'Nombre',
        category: 'Categoría',
        customCategory: 'Categoría propia',
        zone: 'Zona',
        priceInfo: 'Precio',
        visited: 'Visitado',
        airline: 'Aerolínea',
        flightNumber: 'Número de vuelo',
        departureTime: 'Salida',
        arrivalTime: 'Llegada',
        bookingRef: 'Localizador',
        address: 'Dirección',
        checkIn: 'Entrada',
        checkOut: 'Salida',
        bookingUrl: 'Enlace de la reserva',
        type: 'Tipo',
        date: 'Fecha',
        endDate: 'Fecha de fin',
        endTime: 'Hora de fin',
        venue: 'Lugar',
        description: 'Descripción',
        amount: 'Importe',
        content: 'Texto',
        text: 'Artículo',
        checked: 'En la maleta',
        slot: 'Comida',
        bought: 'Comprado',
        unit: 'Unidad',
      },
      entity: {
        day_one: 'día', day_other: 'días',
        venue_one: 'lugar', venue_other: 'lugares',
        flight_one: 'vuelo', flight_other: 'vuelos',
        hotel_one: 'alojamiento', hotel_other: 'alojamientos',
        booking_one: 'reserva', booking_other: 'reservas',
        expense_one: 'gasto', expense_other: 'gastos',
        note_one: 'nota', note_other: 'notas',
        tip_one: 'consejo', tip_other: 'consejos',
        packing_section_one: 'sección de la maleta', packing_section_other: 'secciones de la maleta',
        packing_item_one: 'artículo de la maleta', packing_item_other: 'artículos de la maleta',
        outfit_piece_one: 'prenda prevista', outfit_piece_other: 'prendas previstas',
        meal_one: 'comida', meal_other: 'comidas',
        grocery_item_one: 'línea de la compra', grocery_item_other: 'líneas de la compra',
      },
      yes: 'Sí',
      no: 'No',
      editItem: 'Cambiar «{{label}}»',
      deleteItems_one: 'Borrar {{count}} elemento',
      deleteItems_other: 'Borrar {{count}} elementos',
      packed: '✓ {{item}} metido',
      unpacked: '○ {{item}} aún por meter',
      nights_one: '{{count}} noche',
      nights_other: '{{count}} noches',
      at: 'En {{place}}',
      editStop: 'Cambiar «{{title}}»',
      packingItems: 'Maleta',
      note: 'Nota',
      day: 'Día {{n}}',
      grocery: 'Lista de la compra',
      flight: 'Vuelo',
      stay: 'Alojamiento',
      booking: 'Reserva',
    },
    acceptAll: 'Aceptar todas',
    accept: 'Aceptar',
    discard: 'Descartar',
    sendHint: 'Enter para enviar · Shift+Enter nueva línea',
    open: 'Abierto',
    closed: 'Cerrado',
    willSaveToPlaces: 'Se guarda en Places',
    move: 'Mover: {{title}}',
    afterStop: 'después de {{title}}',
    placeholder: {
      places: '"Quiero guardar La Mar en el Barrio Gótico"',
      itinerary: '"Añade visita al Sagrada Família el día 2"',
      allroutes: '"Haz que el día 2 sea una ruta circular" o "Quita la parada del museo"',
      packing: '"Propón una lista de equipaje" o "Añade una sección de playa"',
      tips: '"Dame consejos sobre transporte y dinero"',
      bookings: '"¿Cuánto tiempo tengo entre vuelos de conexión?"',
      expenses: '"¿Cuánto llevamos gastado en comida?" o "¿Quién debe a quién?"',
      general: "\"Planifícame el día 3\" o \"¿Qué me llevo?\"",
    },
    welcome: {
      places: '¡Hola! Cuéntame sobre sitios que quieras guardar y te los propondré para tu lista de Places.',
      itinerary: '¡Hola! Puedo proponer actividades para tu itinerario o moverlas. Tú decides si las aceptas.',
      allroutes: '¡Hola! Puedo reordenar paradas para minimizar desplazamientos, hacer rutas circulares, mover actividades entre días o eliminar paradas. Tú decides qué aceptas.',
      packing: '¡Hola! Puedo proponerte una lista de equipaje adaptada a tu viaje. Tú decides si la aceptas.',
      tips: '¡Hola! Puedo proponerte consejos prácticos para tu destino. Tú decides si los guardas.',
      bookings: '¡Hola! Pregúntame lo que quieras sobre tus vuelos y hoteles: horarios, conexiones, check-in y logística.',
      expenses: '¡Hola! Pregúntame sobre tus gastos, presupuesto y saldos: totales por categoría, quién debe a quién o cómo repartir costes.',
      general: "¡Hola! Pregúntame lo que quieras del viaje: sitios, el plan, la maleta, las reservas o los gastos. Tú decides qué te quedas.",
    },
    // The vocabulary that unlocks the assistant, made visible: an empty
    // input box teaches nobody what it can do.
    suggestions: {
      general: ["Planifícame el día 1", "Proponme sitios para mis intereses", "¿Qué me llevo?"],
      places: ["Proponme sitios para mis intereses", "Dónde comer bien y barato", "Algo que hacer si llueve"],
      itinerary: ["Planifícame el día 1", "Este día va muy cargado", "Añade una cena el día 2"],
      allroutes: ["Optimiza la ruta de este día", "Hazla circular", "Mueve esta parada a otro día"],
      packing: ["¿Qué me llevo?", "¿Algo para el tiempo que hará?"],
      tips: ["Consejos para moverme", "¿Qué debería saber antes de ir?"],
      bookings: ["¿A qué hora aterrizo?", "¿Cuánto dura mi escala?"],
      expenses: ["¿Cuánto llevo gastado?", "¿Quién debe a quién?", "¿Voy dentro del presupuesto?"],
    },
    category: {
      RESTAURANT: 'Restaurante', CAFE: 'Café', ATTRACTION: 'Atracción',
      VIEWPOINT: 'Mirador', NEIGHBORHOOD: 'Barrio', PARK: 'Parque',
      SHOP: 'Tienda', EXPERIENCE: 'Experiencia', TRANSPORT_HUB: 'Transporte',
      BEACH: 'Playa', NATURE: 'Naturaleza', PARKING: 'Parking', OTHER: 'Otro',
    },
    context: { places: 'Lugares', itinerary: 'Itinerario', packing: 'Equipaje', tips: 'Consejos', bookings: 'Reservas', expenses: 'Gastos', general: 'Viaje' },
    packingTitle: 'Lista de equipaje',
    packingItems_one: '{{count}} artículo',
    packingItems_other: '{{count}} artículos',
    packingGoToTab: 'Abrir la pestaña Maleta',
    budgetTitle: 'Presupuesto propuesto',
    dayPlanTitle: 'Plan del día',
    dayNumber: 'Día {{number}}',
    showPhotos: 'Ver fotos',
    activitiesCount_one: '{{count}} actividad',
    activitiesCount_other: '{{count}} actividades',
    acceptDay: 'Aceptar día',
    reorderTitle: 'Reordenar',
    applyOrder: 'Aplicar orden',
    applying: 'Aplicando…',
    review: {
      places: 'Revisar lugares',
      itinerary: 'Revisar actividades añadidas',
      packing: 'Revisar maleta',
      tips: 'Revisar consejos',
      expenses: 'Revisar gastos',
    },
    tipsTitle: 'Consejos',
    tipsCount_one: '{{count}} consejo',
    tipsCount_other: '{{count}} consejos',
  },
  services: {
    title: 'Servicios del viaje',
    subtitle: 'Socios seleccionados para gestionar los detalles aburridos antes de volar. Actívalos antes de salir — paga con Gromly, tenlo todo en este viaje.',
    partnership: 'Socios de Gromly.',
    partnershipNote: 'Ganamos una pequeña comisión cuando compras a través de nuestros enlaces — el precio que pagas es el mismo o menor con nuestro código.',
    connectivity: {
      label: 'Conectividad',
      eSIM: 'eSIM',
      coverage: 'Cobertura',
      euRoaming: 'Roaming UE',
      heading: 'Conéctate en el momento que aterrizas',
      body: 'Sin cambio de SIM física. Escanea el QR antes de volar y tu teléfono capta datos en cuanto el avión toca tierra.',
      editorsPick: 'Elección del editor',
      from: 'Desde',
      viewPlans: 'Ver planes',
      holafly: {
        subtitle: 'eSIMs con datos ilimitados',
        description: 'El favorito de los blogs de viaje — activación rápida, soporte en español, planes de hasta 30 días para viajeros lentos.',
        feature1: 'Planes de datos ilimitados',
        feature2: 'Chat 24/7 en español e inglés',
        feature3: '5, 10, 15 o 30 días',
        discountNote: '5% de descuento — usa el código GROMLY al pagar',
        price: '€19',
        priceNote: 'por 5 días · {{destination}}', priceNoteGeneric: 'por 5 días',
      },
    },
  },
  notes: {
    loadError: 'Error al cargar las notas', saveError: 'Error al guardar la nota',
    createError: 'Error al crear la nota', deleteConfirm: '¿Eliminar esta nota?',
    deleteError: 'Error al eliminar la nota',
    untitled: 'Sin título', empty: 'Sin contenido',
    new: 'Nueva', emptyState: 'Aún no hay notas', createFirst: 'Crear tu primera nota',
    selectOrCreate: 'Selecciona una nota o crea una nueva',
    allNotes: 'Todas las notas', saved: 'Guardado', delete: 'Eliminar nota',
    titleLabel: 'Título', contentLabel: 'Contenido',
    titlePlaceholder: 'Título de la nota', contentPlaceholder: 'Escribe aquí tus notas…',
    uploadError: 'Error al subir el archivo', deleteDocError: 'Error al eliminar el archivo',
    attachments: 'Archivos adjuntos', upload: 'Subir',
    dropHere: 'Haz clic para adjuntar archivos (imágenes o PDFs)',
  },
  album: {
    ownPhotos: { title: "Tus fotos para el álbum", upload: "Subir", hint: "Sólo en tu álbum: no van a la Galería y nadie más del viaje las ve.", tripPhotos: "Fotos del viaje", remove: "Quitar esta foto de tu álbum" },
    redoDay: { button: "Rehacer este día", confirmTitle: "¿Rehacer este día desde el diario?", confirmBody_one: "Su página se vuelve a hacer con las fotos y el texto del día. Lo que hayas cambiado en ella se pierde.", confirmBody_other: "Sus {{count}} páginas se vuelven a hacer con las fotos y el texto del día. Lo que hayas cambiado en ellas se pierde." },
    wizard: {
      title_create: "Crea tu álbum", title_restart: "Empezar el álbum de nuevo", steps: "Pasos", next: "Siguiente",
      submit_create: "Crear álbum", submit_restart: "Empezar de nuevo", restartWarning: "Todas las páginas se vuelven a hacer desde el diario. Las fotos que subiste al álbum se quedan.",
      format: { step: "Formato", title: "Tamaño y forma", body: "Puedes cambiarlo cuando quieras; las páginas conservan lo que tienen." },
      theme: { step: "Estilo", title: "El estilo del álbum", body: "Papel y colores. La tipografía y los marcos de foto están en el editor." },
      density: { step: "Fotos", title: "¿Cuántas fotos por día?", body: "Las fotos que elegiste en el diario entran siempre; esto sólo dice cuántas más se añaden.",
        FEW: "Pocas", FEW_hint: "Hasta 2 por día", NORMAL: "Equilibrado", NORMAL_hint: "Hasta 6 por día", ALL: "Todas", ALL_hint: "Todas las fotos de cada día",
        pages_one: "{{count}} página", pages_other: "{{count}} páginas", tooLong: "Más de {{max}} páginas: se corta el final" },
      cover: { step: "Portada", title: "La foto de portada", body: "Puedes cambiarla después desde la página de portada." },
    },
    emptyTitle: 'Tu álbum del viaje',
    emptyBody: 'Lo empezamos con tu diario y tus fotos, una página por día. Después eliges el diseño, las fotos y los textos. Solo lo ves tú.',
    create: 'Crear mi álbum',
    loadError: 'No se ha podido cargar tu álbum', saveError: 'No se ha podido guardar el álbum',
    page: 'Página {{number}}', template: 'Diseño', addPage: 'Añadir página',
    deletePageN: 'Borrar la página {{number}}',
    deletePage: 'Borrar página', deletePageConfirm: '¿Borrar esta página del álbum?',
    restart: 'Empezar de nuevo desde el diario',
    templates: { COVER: 'Portada', STATS: 'En cifras', ONE_PHOTO: 'Una foto', TWO_PHOTOS: 'Dos fotos', THREE_PHOTOS: 'Tres fotos', FOUR_PHOTOS: 'Cuatro fotos', TEXT_PHOTO: 'Texto y foto', TRIP_MAP: "Mapa del viaje", DAY_MAP: "Mapa del día", TEXT_ONLY: 'Texto', FULL_BLEED: 'A sangre', TWO_PHOTOS_ASYM: 'Grande y pequeña', THREE_STRIPS: 'Tres en franja', FIVE_PHOTOS: 'Cinco fotos', SIX_PHOTOS: 'Seis fotos', MOSAIC: 'Mosaico', TWO_PHOTOS_TEXT: 'Dos fotos y texto', QUOTE: 'Cita', PANORAMA: 'Panorámica', PANORAMA_FRAMED: 'Panorámica con márgenes', TRIP_MAP_SPREAD: 'Mapa a doble página', COVER_WRAP: 'Foto envolvente', COVER_FULL: "Foto a toda página", COVER_TYPE: "Tipográfica", COVER_FRAMED: "Foto enmarcada", COVER_MOSAIC: "Cuatro fotos", COVER_MAP: "Mapa del viaje", COVER_WRAP_FRAMED: "Tapa enmarcada", COVER_WRAP_TWO: "Tapa con dos fotos" },
    spread: { cover: 'Tapa', back: 'Contraportada', front: 'Portada', wrap: 'Tapa entera', pages: 'Páginas {{pages}}', add: 'Añadir dos páginas', delete: 'Borrar estas dos páginas', deleteN: 'Borrar páginas {{pages}}', deleteConfirm: '¿Borrar estas dos páginas del álbum?', swap: 'Intercambiar izquierda y derecha', endpaper: 'Interior de la tapa: aquí no se imprime nada', join: 'Unirlas', joinTitle: '¿Unir las dos páginas?', joinBody: 'Este diseño ocupa las dos páginas. Lo que no quepa de la página de enfrente se perderá.' },
    spine: { title: 'Lomo', placeholder: 'Título en el lomo', width: 'Unos {{mm}} mm de ancho: el ancho exacto depende de la imprenta.', tooThin: 'Unos {{mm}} mm: un título necesita {{min}} mm. Añade páginas para que quepa.' },
    templateGroups: { label: "Ir a los diseños", covers: "Portadas", '1': '1', '2': '2', '3': '3', '4+': '4+', text: 'Texto', map: 'Mapa', spread: 'Doble página' },
    templateSections: { 'covers': "Portadas", '1': "Una foto", '2': "Dos fotos", '3': "Tres fotos", '4+': "Cuatro fotos o más", 'text': "Texto", 'map': "Mapas y cifras", 'spread': "Doble página" },
    slot: { PHOTO: 'Añade una foto', TITLE: 'Añade un título', TEXT: 'Añade texto', MAP: "Elige el día" },
    statsTitle: 'El viaje en cifras',
    choosePhoto: 'Elige una foto', removePhoto: 'Quitar la foto', used: 'Usada',
    noPhotos: 'Este viaje aún no tiene fotos. Súbelas en el Diario.',
    selectHint: 'Haz clic en un recuadro de la página para rellenarlo, o arrastra una foto encima.',
    chars: '{{count}} / {{max}}', tooLong: 'Demasiado largo para este recuadro: acórtalo o elige un diseño con más espacio.',
    fromDiary: 'Insertar del diario', entryOption: 'Día {{number}} · {{text}}',
    dayN: "Día {{n}}", chooseDay: "Elige el día",
    tripMapHint: "El mapa del viaje se dibuja solo con tu itinerario: cada día, en su color.",
    figures: { legend: "Leyenda", map: "Mapa", world: "Mundo", country: "País", show: "Mostrar", route: "Ruta", stops: "Solo puntos", outline: "Contorno", outlineShow: "Mostrar", outlineHide: "Ocultar", kmCaption: "Kilómetros por carretera" },
    preview: { open: "Hojear", title: "Vista previa del álbum", prev: "Página anterior", next: "Página siguiente" },
    style: { typeface: "Tipografía", font: "Letra", fontOfAlbum: "La del álbum", sizeDown: "Más pequeña", sizeUp: "Más grande", photoFrame: "Marco de las fotos", textSize: "Tamaño del texto", textAlign: "Alineación", size_S: "Pequeño", size_M: "Mediano", size_L: "Grande", align_left: "Izquierda", align_center: "Centro", align_right: "Derecha", theme: "Tema del álbum", pageBackground: "Fondo de esta página", fromTheme: "Tema", veil: "Velo", veil_dark: "Velo oscuro", veil_light: "Velo claro", removePhoto: "Quitar la foto", photoBackground: "Poner una foto de fondo" },
    themes: { paper: "Papel", minimal: "Minimal", night: "Noche", sand: "Arena", sage: "Salvia", kraft: "Kraft" },
    backgrounds: { paper: "Papel", white: "Blanco", sand: "Arena", sage: "Salvia", sky: "Cielo", blush: "Rosa", kraft: "Kraft", night: "Noche", forest: "Bosque", ink: "Tinta", "paper-dots": "Papel de puntos", "paper-grid": "Papel cuadriculado", "white-notebook": "Libreta", "sand-stripes": "Arena a rayas", "sage-dots": "Salvia de puntos", "night-dots": "Noche estrellada" },
    format: { title: "Tamaño y orientación", "a4-portrait": "A4 vertical", "a5-portrait": "A5 vertical", "a4-landscape": "A4 horizontal", "a5-landscape": "A5 horizontal", "square-30": "Cuadrado 30", "square-20": "Cuadrado 20" },
    fontPairs: { classic: "Clásica", modern: "Moderna", handwritten: "Manuscrita", typewriter: "Máquina de escribir", elegant: "Elegante", editorial: "Editorial", rounded: "Redondeada", poster: "Cartel", script: "Caligrafía", retro: "Retro" },
    photoFrames: { none: "Sin marco", "white-border": "Borde blanco", rounded: "Redondeado", shadow: "Sombra" },
    tabs: { page: "Página", album: "Álbum" },
  },
  journal: {
    views: { list: 'Lista', map: 'Mapa' },
    map: { empty: 'Aún no hay fotos en el mapa', emptyBody: 'Una foto sale aquí cuando está vinculada a una parada con ubicación.', unavailable: 'El mapa no está disponible ahora mismo.', unplaced_one: '{{count}} foto sin lugar', unplaced_other: '{{count}} fotos sin lugar' },
    title: 'Diario',
    empty: { title: 'Aún no hay nada escrito', body: 'Elige un día y cuenta qué habéis hecho, con vuestras fotos.' },
    write: 'Escribir',
    placeholder: '¿Qué habéis hecho hoy? ¿Qué querréis recordar?',
    choosePhotos_one: '{{count}} foto elegida',
    choosePhotos_other: '{{count}} fotos elegidas',
    addPhotos: 'Añadir fotos',
    noPhotosToChoose: 'Aún no hay fotos de este día. Añádelas desde aquí.',
    sharedLabel: 'Lo verán los seguidores del enlace',
    sharedHint: 'Desmárcalo para que esta entrada sea sólo del grupo.',
    groupOnly: 'Sólo el grupo',
    groupOnlyHint: 'Los seguidores del enlace no ven esta entrada',
    deleteConfirm: '¿Borrar esta entrada del diario? Sus fotos se quedan en el viaje.',
    loadError: 'No se ha podido cargar el diario',
    saveError: 'No se ha podido guardar la entrada',
    deleteError: 'No se ha podido borrar la entrada',
    previousPhoto: 'Foto anterior',
    nextPhoto: 'Foto siguiente',
  },
  stats: {
    title: 'Tus viajes',
    km: 'km',
    days_one: 'día', days_other: 'días',
    stops_one: 'parada', stops_other: 'paradas',
    photos_one: 'foto', photos_other: 'fotos',
    entries_one: 'entrada', entries_other: 'entradas',
    trips_one: 'viaje', trips_other: 'viajes',
    nights_one: 'noche', nights_other: 'noches',
    countries_one: 'país', countries_other: 'países',
    regions_one: 'continente', regions_other: 'continentes',
    mapLabel_one: 'Mapa con {{count}} país visitado', mapLabel_other: 'Mapa con {{count}} países visitados',
  },
  gallery: {
    noStop: 'Sin parada', stopLabel: 'Parada',
    title: 'Galería', upload: 'Subir fotos', uploading: 'Subiendo…',
    empty: {
      title: 'Todavía no hay fotos', dayTitle: 'Todavía no hay fotos para este día',
      subtitle: 'Arrástralas aquí o súbelas desde tu dispositivo.',
    },
    allDays: 'Todas',
    dayOption: 'Día {{number}}', unassignedDay: 'Sin día', uploadedBy: 'Por {{name}}',
    download: 'Descargar original', delete: 'Eliminar foto',
    deleteConfirm: '¿Eliminar esta foto? No se puede deshacer.',
    loadError: 'Error al cargar las fotos', uploadError: 'Error al subir {{name}}',
    deleteError: 'Error al eliminar la foto', moveError: 'Error al mover la foto',
    selection: { moveToDay: "Mover a un día", searchStop: "Busca una parada", noStopMatch: "Ninguna parada coincide", count_one: "{{count}} seleccionada", count_other: "{{count}} seleccionadas", all: "Seleccionar todo", none: "Quitar selección", selectPhoto: "Seleccionar foto", unselectPhoto: "Quitar foto de la selección", place: "Asignar sitio", stopHint: "Las fotos de otro día pasan al día del sitio que elijas.", deleteConfirm_one: "¿Eliminar esta foto? No se puede deshacer.", deleteConfirm_other: "¿Eliminar {{count}} fotos? No se puede deshacer.", updated_one: "{{count}} foto actualizada", updated_other: "{{count}} fotos actualizadas", updateFailed: "No se pudieron cambiar {{count}} de {{total}} fotos", deleted_one: "{{count}} foto eliminada", deleted_other: "{{count}} fotos eliminadas", deleteFailed: "No se pudieron eliminar {{count}} de {{total}} fotos" },
    // ADR-0058
    suggest: { button: "Sugerir sitios", hint: "La IA mira las fotos y sugiere la parada del viaje donde se hizo cada una. 1 crédito de IA cada 10 fotos.", title: "Sitios sugeridos por la IA", looking: "Mirando {{count}} fotos…", summary: "Ha encontrado parada para {{found}} de {{total}} fotos. Marca las que estén bien.", none: "Sin sugerencia", unsure: "No está segura", alreadyThere: "ya está ahí", apply: "Aplicar ({{count}})", privacy: "Las fotos se envían a OpenAI para analizarlas.", failed: "No se han podido sugerir sitios. Vuelve a probar." },
    placedByDate_one: '{{count}} foto colocada en su día según la fecha en que se hizo', placedByDate_other: '{{count}} fotos colocadas en su día según la fecha en que se hicieron',
  },
  billing: {
    credits: { label: 'Créditos de viaje' },
    paywall: {
      title: "Hazte PRO",
      description: "Has usado tus viajes gratuitos. PRO es un plan anual con viajes ilimitados y hasta 500 peticiones de IA al mes.",
      perks: ["Viajes ilimitados", "500 peticiones de IA al mes", "Todo lo que ya usas, sin límites"],
      cta: "Hazte PRO",
      error: "Error al iniciar el pago. Inténtalo de nuevo.",
    },
    aiPaywall: {
      title: "Sin peticiones de IA",
      description: "Has usado tus peticiones gratuitas de IA. PRO incluye 500 al mes.",
      cta: "Hazte PRO",
      error: "Error al iniciar el pago. Inténtalo de nuevo.",
    },
    payment: {
      success: "¡Bienvenido a PRO! Puede tardar unos segundos en aparecer.",
      cancelled: "Pago cancelado.",
    },
  },
  landing: {
    nav: {
      features: 'Funciones',
      ai: 'IA',
      community: 'Comunidad',
      marketplace: 'Marketplace',
      signIn: 'Iniciar sesión',
      getStarted: 'Empezar',
    },
    hero: {
      eyebrow: 'Donde empieza cada viaje',
      headline1: 'Planifica cada',
      headline2: 'aventura.',
      subheading: 'Itinerarios, gastos, reservas y lugares para visitar — todo en un mismo sitio, compartido solo con quienes viajan contigo.',
      pills: {
        itinerary: 'Itinerario',
        expenses: 'Gastos',
        aiRoutes: 'Rutas IA',
        plane: 'Vuelo',
        bookings: 'Reservas',
        collaborative: 'Colaborativo',
      },
      ctaPrimary: 'Empezar gratis',
      ctaSecondary: 'Iniciar sesión',
    },
    mock: {
      nightsLabel: '{{range}} · {{count}} NOCHES',
      tripTitle: 'Verano en Islandia',
      active: 'ACTIVO',
      moreCount: '+{{count}} más',
      totalSpent: 'GASTADO',
      ofBudget: 'de {{amount}} presupuesto',
      activities: 'ACTIVIDADES',
      acrossDays: 'en {{count}} días',
      dayHeader: 'DÍA {{day}} — {{place}}',
      routeOptimized: 'Ruta optimizada',
      splitSettled: 'División saldada · {{count}}p',
      aiOptimized: 'IA Optimizado · Día {{day}}',
      whoOwesWhom: 'QUIÉN DEBE A QUIÉN',
      settle: 'Saldar',
      settledCount: 'SALDADOS · {{count}}',
    },
    ticker: {
      label: 'Viajes planeados en',
    },
    features: {
      eyebrow: 'Todo lo que necesitas',
      headlineLine1: 'Un solo lugar para cada parte',
      headlineLine2Pre: 'del',
      headlineLine2Highlight: 'viaje.',
      description: 'Pensado para viajes reales, no idealizados. Controla desde el vuelo hasta la reserva del restaurante.',
      cards: {
        itinerary: {
          title: 'Itinerario día a día',
          desc: 'Crea un itinerario arrastrable con actividades, horarios y categorías. Compártelo en directo con todo el grupo.',
        },
        expenses: {
          title: 'Gastos y divisiones',
          desc: 'Registra cada gasto, divide los costes entre el grupo y mira exactamente quién debe a quién con un toque para saldar.',
        },
        ai: {
          title: 'Optimizador de rutas IA',
          desc: 'Indícale a la IA tus preferencias y reordena las paradas para minimizar el tiempo de viaje. Acepta lenguaje natural.',
        },
        bookings: {
          title: 'Centro de reservas',
          desc: 'Gestiona vuelos, hoteles, transporte y eventos en un solo sitio. Adjunta PDFs, números de referencia y recordatorios.',
        },
        map: {
          title: 'Mapa y lugares',
          desc: 'Descubre sitios, márcalos como visitados y añádelos a tu itinerario directamente desde la vista del mapa.',
        },
        collaborative: {
          title: 'Planificación colaborativa',
          desc: 'Invita a tu grupo, asigna roles y planificad juntos. Todos ven los cambios en tiempo real, sin hojas de cálculo.',
        },
      },
    },
    ai: {
      eyebrow: 'Impulsado por IA',
      headline1: 'Tu optimizador',
      headline2: 'de viajes personal.',
      description: 'Cuéntale a la IA tus preferencias en lenguaje natural — horarios de comida, sitios imprescindibles, cómo te gusta viajar — y reconstruye tu día en segundos.',
      chips: {
        route: 'Optimización de ruta',
        hints: 'Lenguaje natural',
        mode: 'Modo de transporte',
        grouping: 'Agrupación por zonas',
      },
      cta: 'Pruébalo gratis',
    },
    groups: {
      eyebrow: 'Pensado para grupos',
      headline1: 'Planifiquen juntos,',
      headline2: 'no por separado.',
      description: 'Invita a tu grupo, asigna editores o espectadores, y divide cada gasto automáticamente. Un toque para saldar — sin mensajes incómodos por WhatsApp.',
      features: {
        invite: 'Invitar con enlace, gestionar roles',
        split: 'Cálculo automático de divisiones',
        settle: 'Saldar deudas con un toque',
        sync: 'Sincronización en tiempo real',
      },
      morePlanning: 'planificando juntos',
      morePrefix: '+{{count}} más',
    },
    marketplace: {
      eyebrow: 'Marketplace de la comunidad',
      headline1: 'Descubre viajes',
      headline2: 'de la comunidad.',
      description: 'Explora itinerarios públicos de viajeros de todo el mundo. Clona cualquier viaje con un clic y adáptalo a tus fechas, grupo y presupuesto — sin empezar de cero.',
      features: {
        browse: 'Explora itinerarios públicos seleccionados',
        clone: 'Clona y personaliza cualquier viaje',
        ratings: 'Valoraciones y opiniones de la comunidad',
        follow: 'Sigue a viajeros que admiras',
      },
      cta: 'Explorar la comunidad',
      cloneTrip: 'Clonar viaje',
      nights: '{{country}} · {{count}} noches',
      tripTags: {
        nature: 'Naturaleza',
        culture: 'Cultura',
        adventure: 'Aventura',
        hiking: 'Senderismo',
        beach: 'Playa',
        food: 'Gastronomía',
        souks: 'Zocos',
      },
    },
    bottomCta: {
      eyebrow: 'Empieza gratis',
      headline1: 'Tu próxima aventura',
      headline2: 'empieza aquí.',
      description: 'Únete a miles de viajeros que planifican mejor, dividen gastos justos y guardan mejores recuerdos.',
      button: 'Crear cuenta gratis',
      haveAccount: 'Ya tengo cuenta',
      fineprint: 'No se necesita tarjeta · Plan gratuito disponible para siempre',
    },
    footer: {
      privacy: 'Privacidad',
      terms: 'Términos',
      legal: 'Aviso legal',
      copyright: '© MMXXVI GROMLY · VESTIGI PLATFORM, S.L.',
    },
  },
  explore: {
    toast: {
      loadFailed: 'Error al cargar los viajes',
      tripNotFound: 'Viaje no encontrado',
      ratingFailed: 'Error al valorar',
      followFailed: 'No se pudo actualizar el seguimiento',
      cloned: 'Viaje añadido a tu cuenta!',
      cloneFailed: 'Error al clonar',
      insufficientCredits: 'No te quedan créditos de viaje. Mejora tu plan para conseguir más.',
    },
    breadcrumb: 'Comunidad · Plantillas',
    heading: 'Explorar viajes',
    searchPlaceholder: 'Destino o viaje…',
    feed: { all: 'Todos', following: 'Siguiendo' },
    filters: {
      days: 'Días', any: 'Cualquiera', clear: 'Limpiar',
      button: 'Filtros',
      title: 'Filtros',
      sortBy: 'Ordenar por',
      destination: 'Destino',
      destinationPlaceholder: 'ej. París, Italia…',
      nights: 'Noches',
      budgetPerDay: 'Presupuesto por día',
      budgetHint: 'Calculado a partir del gasto real dividido entre la duración del viaje.',
      activities: 'Tipos de actividad',
      month: 'Mes del viaje',
      anyMonth: 'Cualquier mes',
      participants: 'Tamaño del grupo',
      min: 'Mín',
      max: 'Máx',
      apply: 'Aplicar',
      reset: 'Restablecer',
      clearAll: 'Quitar todo',
      activityType: {
        RESTAURANT: 'Restaurante',
        CAFE: 'Café',
        MONUMENT: 'Monumento',
        VIEWPOINT: 'Mirador',
        NEIGHBORHOOD: 'Barrio',
        PARK: 'Parque',
        SHOP: 'Tienda',
        EXPERIENCE: 'Experiencia',
        TRANSPORT: 'Transporte',
        PARKING: 'Parking',
        BEACH: 'Playa',
        NATURE: 'Naturaleza',
        ACCOMMODATION: 'Alojamiento',
        OTHER: 'Otro',
      },
    },
    sort: { recent: 'Más recientes', topRated: 'Mejor valorados', mostUsed: 'Más usados' },
    results: {
      trips_one: '{{count}} viaje',
      trips_other: '{{count}} viajes',
      days_one: '{{count}} día',
      days_other: '{{count}} días',
    },
    empty: {
      title: 'No se encontraron viajes',
      body: 'Prueba otra búsqueda o filtro.',
    },
    loadMore: 'Cargar más',
    detail: {
      backToExplore: 'Explorar',
      mapUnavailable: 'Mapa no disponible',
      allPlaces: 'Todos los lugares',
      dayByDay: 'Día a día',
      dayLabel: 'Día {{n}}',
      stops_one: '{{count}} parada',
      stops_other: '{{count}} paradas',
      calculatingRoute: 'Calculando ruta…',
      noStopsToday: 'No hay paradas con ubicaciones este día.',
      stopFallback: 'Parada {{n}}',
      openInMaps: 'Abrir en mapas',
      noItinerary: 'Sin itinerario planeado.',
      activities_one: '{{count}} actividad',
      activities_other: '{{count}} actividades',
      noActivities: 'Sin actividades planificadas',
      noPlaces: 'Sin lugares listados.',
      noTips: 'Sin tips compartidos.',
      actualSpend: 'Gasto real',
      tripNotes: 'Notas del viaje',
      useAsTemplate: 'Usar como plantilla',
      used: 'Usado',
      times_one: '{{count}} vez',
      times_other: '{{count}} veces',
      communityRating: 'Valoración de la comunidad',
      noRatingsYet: 'Sin valoraciones aún',
      ratings_one: '{{count}} valoración',
      ratings_other: '{{count}} valoraciones',
      rateThisTrip: 'Valora este viaje',
      youRated_one: 'Has valorado con {{count}} estrella',
      youRated_other: 'Has valorado con {{count}} estrellas',
      tripDetails: 'Detalles del viaje',
      stats: {
        destination: 'Destino',
        dates: 'Fechas',
        duration: 'Duración',
        people: 'Personas',
        activities: 'Actividades',
        nights_one: '{{count}} noche',
        nights_other: '{{count}} noches',
      },
      author: 'Autor',
      publishedAgo: 'Publicado hace {{time}}',
      follow: 'Seguir',
      following: 'Siguiendo',
      travelMode: {
        WALKING: 'Caminar',
        DRIVING: 'Coche',
        BICYCLING: 'Bici',
        TRANSIT: 'Transporte',
      },
      tabs: {
        itinerary: 'Itinerario',
        places: 'Lugares',
        map: 'Mapa',
        tips: 'Tips e info',
        expenses: 'Presupuesto',
        notes: 'Notas',
      },
    },
    clone: {
      title: 'Usar como plantilla',
      tripName: 'Nombre del viaje',
      whenLabel: '¿Cuándo quieres ir?',
      tripEnds: 'Termina',
      keepOriginalDates: 'Déjalo vacío para mantener las fechas originales.',
      addToMyTrips: 'Añadir a mis viajes',
      daysLabel: 'Días a copiar',
      selectAll: 'Todos',
      clearAll: 'Ninguno',
      selectAtLeastOne: 'Selecciona al menos un día',
      untitledDay: 'Día sin título',
      activitiesCount_one: '{{count}} actividad',
      activitiesCount_other: '{{count}} actividades',
      summaryDays_one: '{{count}} día',
      summaryDays_other: '{{count}} días',
      summaryNights_one: '{{count}} noche',
      summaryNights_other: '{{count}} noches',
    },
  },
  pdf: {
    nights_one: '{{count}} noche', nights_other: '{{count}} noches',
    coverLabel: 'Itinerario de viaje', travellers: 'Viajeros', budget: 'Presupuesto', notes: 'Notas',
    generatedOn: 'Generado el {{date}}',
    itinerary: 'Itinerario', placesToVisit: 'Lugares para visitar', bookings: 'Reservas',
    expenses: 'Gastos', checklists: 'Checklists', tips: 'Consejos',
    meals: 'Comidas', grocery: 'Lista de la compra',
    flights: 'Vuelos', hotels: 'Hoteles', otherReservations: 'Otras reservas',
    balances: 'Balances',
    category: 'Categoría', name: 'Nombre', zone: 'Zona', address: 'Dirección', visited: 'Visitado',
    direction: 'Dirección', route: 'Ruta', departure: 'Salida', arrival: 'Llegada',
    flight: 'Vuelo', ref: 'Ref', outbound: 'Ida', return: 'Vuelta',
    type: 'Tipo', title: 'Título', date: 'Fecha', description: 'Descripción',
    paidBy: 'Pagado por', amount: 'Importe', owes: 'Debe',
    totalSpent: 'Total gastado', perPerson: 'Por persona', checkIn: 'Entrada', checkOut: 'Salida',
  },
  essentials: {
    heading: "Esenciales de {{country}}",
    currency: "Moneda", language: "Idioma", capital: "Capital", callingCode: "Prefijo telefónico",
    plug: "Corriente", plugType: "Tipo", driving: "Conducción", tapWater: "Agua del grifo", emergency: "Emergencias",
    emergencyGeneral: "general", emergencyPolice: "policía", emergencyAmbulance: "ambulancia", emergencyFire: "bomberos",
    drive: { left: "Por la izquierda", right: "Por la derecha" },
    water: { safe: "Potable", caution: "Con precaución", unsafe: "Bebe embotellada" },
    advisory: { normal: "Sin avisos importantes", see_advisory: "Consulta el aviso de viaje", avoid_essential: "Evita viajes no esenciales", avoid_all: "Evita todo viaje" },
    practicalDisclaimer: "Información orientativa — puede variar según la zona.",
    visa: {
      visa_free: "Sin visado", visa_on_arrival: "Visado a la llegada", e_visa: "e-Visado", eta: "Autorización de viaje", visa_required: "Visado obligatorio", no_admission: "Entrada no permitida",
      upToDays_one: "hasta {{count}} día", upToDays_other: "hasta {{count}} días",
    },
    requirements: {
      heading: "Requisitos de entrada", forNationality: "Para pasaporte de {{nationality}}",
      forCountry: "Para entrar en {{country}}",
      visa: "Visado", passport: "Pasaporte", vaccines: "Vacunas", unknown: "No disponible",
      passportValidity_one: "Válido {{count}}+ mes tras tu estancia", passportValidity_other: "Válido {{count}}+ meses tras tu estancia", passportValidZero: "Sin validez extra tras tu estancia",
      noVaccines: "No se exigen vacunas para entrar", mandatory: "Obligatoria",
      checkedOn: "Consultado {{date}}", verifyOfficial: "Verificar oficialmente",
      missingPrompt: "Añade tu nacionalidad para ver requisitos de visado y vacunas", empty: "Aún no hay requisitos que mostrar",
      disclaimer: "Información orientativa, no oficial. Las normas de entrada y sanitarias cambian: confirma siempre con el consulado del destino o una fuente oficial antes de viajar.",
    },
  },
  redeemCode: {
    entry: "Tengo un código",
    title: "Abre tu viaje",
    body: "Tu agencia de viajes te ha dado un código de 8 caracteres. Funciona con el correo que le diste: {{email}}.",
    label: "Código del viaje",
    submit: "Abrir mi viaje",
    joined: "Tu viaje ya está listo",
    errors: {
      notFound: "Ese código no corresponde a ninguna invitación para {{email}}. Revísalo, y comprueba que has entrado con el correo que diste a tu agencia.",
      emailNotVerified: "Primero verifica tu correo: te enviamos un enlace al registrarte.",
      expired: "Este código ha caducado. Pide uno nuevo a tu agencia.",
      revoked: "Tu agencia ha anulado este código. Pídele uno nuevo.",
      tooMany: "Demasiados intentos. Vuelve a probar dentro de una hora.",
      generic: "No hemos podido abrir el viaje. Inténtalo de nuevo.",
    },
  },
  agency: {
    card: {
      preparedBy: "Preparado por",
      emergency: "Teléfono de emergencia",
      email: "Correo",
    },
    managesTravellers: "En este viaje los viajeros los gestiona tu agencia. Pídele que añada a quien falte.",
    panel: {
      tabs: {
        current: "Viajes",
        past: "Pasados",
        templates: "Circuitos",
        clients: "Clientes",
        team: "Equipo",
        settings: "Ajustes",
      },
      currentTab: "En curso",
      newTrip: "Nuevo viaje",
      newTemplate: "Nuevo circuito",
      newDeparture: "Nueva salida",
      duplicate: "Duplicar",
      duplicateName: "{{name}} (copia)",
      duplicateFailed: "No se ha podido duplicar el circuito",
      days_one: "{{count}} día",
      days_other: "{{count}} días",
      nights_one: "{{count}} noche",
      nights_other: "{{count}} noches",
      addDescription: "Añade una descripción",
      descriptionPlaceholder: "Describe el circuito: qué incluye, para quién es…",
      descriptionFailed: "No se ha podido guardar la descripción",
      empty: {
        currentTitle: "No hay viajes en curso",
        currentBody: "Crea un viaje, o una salida de uno de tus circuitos.",
        pastTitle: "Aún no hay viajes pasados",
        pastBody: "Los viajes pasan aquí una semana después de acabar. Desde entonces son de tus clientes.",
        templatesTitle: "Aún no hay circuitos",
        templatesBody: "Un circuito es un viaje que vendes una y otra vez. Prepáralo una vez y crea una salida para cada fecha.",
      },
      managedUntil: "Lo gestionas hasta el {{date}}",
      handedOver: "De tu cliente desde el {{date}}",
      open: "Abrir",
      lead: "Viajero principal",
      status: {
        NOT_INVITED: "Sin invitación",
        INVITED: "Invitado",
        ACTIVATED: "Activado",
        JOINED: "Unido",
      },
      copyCode: "Copiar código",
      codeCopied: "Código copiado",
      activations: {
        title: "Viajeros activados",
        count_one: "{{count}} viajero activado",
        count_other: "{{count}} viajeros activados",
        empty: "Nadie se activó este mes.",
        month: "Mes",
      },
      usage: {
        title: "Este mes",
        maps: "Maps: {{used}} de {{cap}}",
        ai: "IA: {{used}} de {{cap}} peticiones",
      },
      loadFailed: "No se ha podido cargar la agencia",
    },
    home: {
      tagline: "Lo que tienes entre manos hoy.",
      stats: {
        ongoing: "En curso",
        leavingSoon: "Salen en los próximos 7 días",
        pending: "Viajeros sin activar",
        activated: "Activados este mes",
      },
      sections: {
        attention: "Requiere atención",
        ongoing: "En curso",
        upcoming: "Próximas salidas",
        activations: "Últimas activaciones",
        circuits: "Circuitos",
      },
      attentionHint: "Aún no han canjeado su código, y el viaje está en curso o sale en menos de dos semanas.",
      allClear: "Están todos dentro. Ahora mismo nada te necesita.",
      leavesToday: "Sale hoy",
      leavesTomorrow: "Sale mañana",
      leavesIn_one: "Sale en {{count}} día",
      leavesIn_other: "Sale en {{count}} días",
      dayOf: "Día {{day}} de {{total}}",
      activatedOf: "{{done}}/{{total}} activados",
      noUpcoming: "No hay salidas programadas.",
      noActivations: "Nadie se ha activado este mes todavía.",
      allTrips: "Todos los viajes",
      seeAll: "Ver todas",
      emptyTitle: "Tu agencia está lista",
      emptyBody: "Crea tu primer viaje, o un circuito que venderás una y otra vez.",
    },
    departure: {
      title: "Nueva salida: {{name}}",
      name: "Nombre del viaje",
      startDate: "Fecha de inicio",
      travellers: "Viajeros",
      leadHint: "El primero es el propietario del viaje cuando canjea su código.",
      travellerName: "Nombre",
      travellerEmail: "Correo (para enviarle el código)",
      addTraveller: "Añadir viajero",
      removeTraveller: "Quitar",
      submit: "Crear salida",
      created: "Salida creada",
      invitesFailed_one: "{{count}} invitación no se ha podido enviar",
      invitesFailed_other: "{{count}} invitaciones no se han podido enviar",
      failed: "No se ha podido crear la salida",
    },
    settings: {
      brandTitle: "Lo que ven tus viajeros",
      brandHint: "Se muestra dentro del viaje mientras lo gestionas.",
      name: "Nombre de la agencia",
      emergencyPhone: "Teléfono de emergencia",
      contactEmail: "Correo de contacto",
      logo: "Logo",
      uploadLogo: "Subir logo",
      removeLogo: "Quitar logo",
      save: "Guardar",
      saved: "Guardado",
      saveFailed: "No se ha podido guardar",
    },
    clients: {
      title: "Clientes",
      new: "Nuevo cliente",
      edit: "Editar cliente",
      search: "Busca por nombre o email",
      saveFailed: "No se ha podido guardar el cliente",
      loadFailed: "No se ha podido cargar el cliente",
      deleteFailed: "No se ha podido borrar el cliente",
      form: {
        name: "Nombre",
        email: "Email",
        phone: "Teléfono",
        birthDate: "Fecha de nacimiento",
        notes: "Notas",
        emailInvalid: "Ese email no parece correcto",
        emailHint: "Sin email viaja igual, pero no recibe código: alguien del grupo puede compartirle el viaje.",
      },
      picker: {
        noEmail: "Sin email — no recibirá código",
        makeLead: "Hacer viajero principal",
        remove: "Quitar",
        search: "Busca en tus clientes",
        noMatch: "Ningún cliente coincide.",
        emptyBook: "Aún no tienes clientes: da de alta el primero.",
        createNamed: "Nuevo cliente «{{name}}»",
      },
      bornOn: "Nacido el {{date}}",
      hasAccount: "Tiene cuenta",
      trips: "Viajes con vosotros",
      noTrips: "Todavía ningún viaje.",
      deleteTitle: "¿Borrar a {{name}}?",
      deleteBody: "Sale de tu cartera de clientes. Sus viajes siguen siendo suyos.",
      noMatchTitle: "Ningún cliente coincide",
      emptyTitle: "Aún no tienes clientes",
      emptyBody: "Cada viajero que añades a un viaje queda aquí, para que la próxima vez solo tengas que elegirlo.",
      noContact: "Sin datos de contacto",
      tripCount_one: "{{count}} viaje",
      tripCount_other: "{{count}} viajes",
    },
    team: {
      loadFailed: "No se ha podido cargar el equipo",
      lastAdmin: "La agencia necesita al menos un admin.",
      failed: "Algo ha fallado",
      invited: "Invitación enviada a {{email}}",
      alreadyMember: "Ya está en el equipo.",
      inviteTitle: "Invitar al equipo",
      inviteHint: "Recibirá un email y entrará cuando acepte con esa dirección. Sus viajes personales siguen siendo suyos.",
      emailPlaceholder: "compañera@agencia.com",
      role: "Rol",
      roles: {
        ADMIN: "Admin",
        AGENT: "Agente",
      },
      invite: "Invitar",
      you: "(tú)",
      remove: "Quitar a {{name}}",
      pending: "Pendiente",
      revoke: "Cancelar invitación",
      removeTitle: "¿Quitar a {{name}} del equipo?",
      removeBody: "Pierde el acceso a los viajes y clientes de la agencia. Sus viajes personales siguen siendo suyos.",
      removeConfirm: "Quitar",
    },
    invite: {
      gone: {
        expired: "Esta invitación ha caducado",
        used: "Esta invitación ya se ha usado",
        notFound: "Esta invitación no existe",
      },
      goneBody: "Pide a la agencia que te envíe otra.",
      goHome: "Ir a mi inicio",
      accepted: "Bienvenido a {{agency}}",
      verifyFirst: "Verifica tu email primero y luego acepta.",
      failed: "No se ha podido aceptar la invitación",
      eyebrow: "Invitación",
      title: "Únete a {{agency}}",
      body: {
        ADMIN: "Como admin: preparas los viajes de sus clientes y gestionas el equipo.",
        AGENT: "Prepararás los viajes de sus clientes.",
      },
      keepTrips: "Tus viajes personales siguen siendo tuyos: cambias entre ellos y la agencia desde el menú de tu perfil.",
      accept: "Aceptar y unirme",
      wrongEmail: "Esta invitación es para {{invited}} y has entrado como {{current}}. Entra con ese email para aceptarla.",
    },
    wizard: {
      ask: "¿Para quién es este viaje?",
      hint: "Elígelos de tus clientes o da de alta uno nuevo. El primero es el viajero principal: el viaje es suyo cuando canjea su código.",
      clientsCount_one: "{{count}} cliente",
      clientsCount_other: "{{count}} clientes",
    },
  },
  admin: {
    loadFailed: "No se ha podido cargar. Vuelve a intentarlo.",
    acting: { inside: "Estás dentro de {{agency}} como Gromly", leave: "Salir", enter: "Entrar" },
    usage: {
      subtitle: "Del {{from}} al {{to}}, comparado con del {{prevFrom}} al {{prevTo}}.", subtitleLoading: "Cargando…",
      rangeLabel: "Periodo", from: "Desde", to: "Hasta",
      range: { month: "Este mes", lastMonth: "Mes pasado", "7d": "7 días", "30d": "30 días", "90d": "90 días", "12m": "12 meses", custom: "Personalizado" },
      segmentLabel: "De quién es el gasto", segment: { all: "Todo", personal: "Viajes personales", agency: "Viajes de agencia" },
      clearFilter: "Dejar de filtrar por {{name}}", deletedUser: "Cuenta eliminada", deletedTrip: "Viaje eliminado",
      vsPrevious: "Respecto al periodo anterior",
      tiles: { total: "Total", maps: "Maps", ai: "IA", users: "Usuarios con gasto", outside: "Fuera de viajes", projection: "Proyección del mes" },
      calls_one: "{{count}} llamada", calls_other: "{{count}} llamadas",
      aiDetail: "{{calls}} llamadas · {{credits}} créditos", perUser: "{{amount}} por usuario",
      outsideDetail: "Búsquedas y el asistente, antes de que exista el viaje", projectionDetail: "Al ritmo de este mes",
      trend: "Gasto en el periodo", trendLabel: "Gasto de Maps e IA en el periodo",
      byMaps: "Maps por servicio", byAi: "IA por función", byModel: "IA por modelo",
      topUsers: "Quién gasta más", topTrips: "Viajes que más cuestan", noAgencySpend: "Ninguna agencia ha gastado en este periodo",
      split: "Maps {{maps}} · IA {{ai}}", mapsCap: "Tope de Maps {{amount}}/mes",
      empty: "Sin gasto en este periodo",
      footnote: "Registrado desde el 27 de julio de 2026. El gasto dentro de un viaje de agencia cuenta para la agencia (ADR-0034); el de fuera de viajes, como personal.",
      maps: { placeResolution: "Encontrar lugares", placeDetails: "Fichas de lugares", photos: "Fotos", search: "Búsqueda y autocompletar", routes: "Rutas", mapLoads: "Cargas de mapa", other: "Otros" },
      ai: { chatQuestion: "Chat · preguntas", chatAction: "Chat · acciones", chatTriage: "Chat · triaje", chat: "Chat · otros", import: "Importar documentos", extraction: "Leer billetes y tickets", wizard: "Asistente de nuevo viaje", essentials: "Información del país" },
    },
    nav: { overview: "Resumen", users: "Usuarios", agencies: "Agencias", usage: "Uso y costes" },
    overview: {
      title: "Gromly de un vistazo", subtitle: "Quién lo usa, de dónde viene y cuánto cuesta.",
      signups: "Altas por mes", trips: "Viajes creados por mes", seeUsers: "Ver usuarios",
      personalTrips: "Personales", agencyTrips: "Con agencia", manageAgencies: "Gestionar agencias",
      footnote: "Los usuarios activos se cuentan desde que empezó a registrarse la actividad. Los viajes de demo y las plantillas de agencia no cuentan como viajes.",
      chartLabel: "Gráfico mensual: {{series}}",
      activations_one: "{{count}} viajero activado este mes", activations_other: "{{count}} viajeros activados este mes",
      maps: "Maps este mes", ai: "Peticiones de IA",
      stats: {
        users: "Usuarios", usersDetail_one: "{{count}} nuevo este mes", usersDetail_other: "{{count}} nuevos este mes",
        active: "Activos (30 días)", activeDetail_one: "{{count}} en los últimos 7 días", activeDetail_other: "{{count}} en los últimos 7 días",
        pro: "PRO", proDetail_one: "{{count}} de regalo", proDetail_other: "{{count}} de regalo",
        fromAgencies: "Llegados por agencias", fromAgenciesDetail_one: "{{count}} ha creado después un viaje propio", fromAgenciesDetail_other: "{{count}} han creado después un viaje propio",
        trips: "Viajes", tripsDetail_one: "{{count}} este mes · {{agency}} con agencia", tripsDetail_other: "{{count}} este mes · {{agency}} con agencia",
        cost: "Coste del mes", costDetail: "Mes pasado: {{amount}}",
      },
    },
    users: {
      total_one: "{{count}} usuario", total_other: "{{count}} usuarios",
      search: "Buscar por nombre, usuario o email", originLabel: "Origen", anyOrigin: "Cualquier origen", tagLabel: "Tipo", anyTag: "Cualquier tipo",
      empty: "Ningún usuario coincide con estos filtros", pagination: "Páginas", prev: "Página anterior", next: "Página siguiente", pageOf: "Página {{page}} de {{pages}}",
      origin: { direct: "Directo", agency: "Por agencia" },
      filter: { staff: "Personal de agencia", traveller: "Viajeros de agencia", pro: "PRO", admin: "Administradores" },
      tags: { staffOf: "Personal · {{agency}}", travellerOf: "Viajero · {{agency}}", pro: "PRO", proGift: "PRO regalado", admin: "Admin" },
      cols: { user: "Usuario", tags: "Perfil", trips: "Viajes", joined: "Alta", lastActive: "Última actividad" },
    },
    user: {
      ownTrips: "Viajes propios", agencyTrips: "Viajes con agencia", usageMonth: "Uso este mes", usageAll: "Uso total",
      aiCredits_one: "{{count}} crédito de IA", aiCredits_other: "{{count}} créditos de IA",
      credits: "Créditos restantes", creditsValue: "{{ai}} IA · {{trips}} viajes",
      pro: {
        title: "PRO", paid: "Paga PRO ({{source}}) hasta el {{date}}. Un PRO pagado no se puede regalar encima ni retirar desde aquí.",
        giftUntil: "PRO regalado hasta el {{date}}.", none: "No es PRO. Puedes regalárselo hasta una fecha.",
        presets: "Duración", months_one: "{{count}} mes", months_other: "{{count}} meses",
        extendMonths_one: "+{{count}} mes", extendMonths_other: "+{{count}} meses",
        until: "Hasta", grant: "Regalar PRO", update: "Cambiar fecha", revoke: "Retirar regalo",
        revokeTitle: "¿Retirar el PRO regalado?", revokeBody: "Deja de ser PRO ahora mismo. No se borra nada de lo que ha creado.",
        granted: "PRO regalado", revoked: "Regalo retirado", alreadyPaid: "Este usuario ya paga PRO", failed: "No se ha podido guardar el cambio",
        historyGranted: "{{date}} · regalado por {{actor}}", historyRevoked: "{{date}} · retirado por {{actor}}", unknownActor: "un admin eliminado",
        source: { STRIPE: "web", APP_STORE: "App Store", PLAY_STORE: "Google Play" },
      },
    },
  },
  adminAgencies: {
    title: "Agencias",
    name: "Nombre",
    contactEmail: "Correo de contacto",
    members: "Personal",
    addMember: "Invitar",
    memberEmail: "Email del admin de la agencia",
    removeMember: "Quitar",
    mapsCap: "Tope de Maps (€/mes)",
    aiCap: "Peticiones de IA / mes",
    activations_one: "{{count}} activado este mes",
    activations_other: "{{count}} activados este mes",
    downloadCsv: "CSV de activados",
    save: "Guardar",
    saved: "Guardado",
    empty: "Aún no hay agencias.",
    invited: "Invitación enviada a {{email}}",
    alreadyMember: "Ya está en el equipo.",
    failed: "Algo ha fallado",
    subtitle: "Las agencias se dan de alta a mano. Su personal necesita antes una cuenta en Gromly.",
    newTitle: "Nueva agencia",
    staffEmpty: "Sin personal todavía: añade el correo de alguien con cuenta en Gromly.",
    limitsTitle: "Topes mensuales",
    limitsHint: "Lo que pueden gastar en Maps e IA todos los viajes de la agencia juntos.",
    billingTitle: "Factura",
    billingHint: "Una línea por viajero activado en el mes.",
    statMaps: "Maps este mes",
    statAi: "IA este mes",
    statActivations: "Activados este mes",
    of: "{{used}} de {{cap}}",
    logoHint: "Pulsa el logo para cambiarlo",
  },
} as const;

export default es;
